import { CDN_DOMAIN } from "../settings";
import { translate } from "../i18n";

const BarInfo = lang => {
  const _t = key => translate(key, lang);

  const langPrefix = lang ? `_${lang}` : "";
  return [{
    type: "adentyPartial",
    title: _t("Частичная адентия"),
    text: _t("<b>Частичная адентия</b> – это частичное отсутствие зубов на челюсти. <br>Она может проявиться вследствие отсутствия зачатков коренных зубов или потери зубов после травмы или удаления. <br>Отсутствие даже одного зуба повлечет за собой перестройку всего зубного ряда. Оставшиеся зубы пытаются закрыть свободное пространство, из-за чего они раздвигаться и разворачиваться. Теряя опору, оставшиеся зубы могут начать раскачиваться, что может также привести к их потере. Все это ведет к изменению прикуса, а впоследствии может повлиять и на состояние височно-нижнечелюстного сустава в целом."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.1-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/partial-adentia.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/partial-adentia_preview.jpg`,
      title: _t("Последствия адентии")
    }, {
      video: `${CDN_DOMAIN}/Videos/Частичная адентия.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Частичная-адентия.png`,
      title: _t("Частичная адентия")
    }],
    photo: [{
      photo: require("./Photos/partial-adentia_1.jpg"),
      title: _t("Изменение положения зубов вследствие адентии")
    }, {
      photo: require("./Photos/partial-adentia_2.jpg"),
      title: _t("Смещение соседних зубов в сторону дефекта")
    }, {
      photo: require("./Photos/partial-adentia_3.jpg"),
      title: _t("Последствия адентии")
    }, {
      photo: require("./Photos/Включенный дефект фронт.jpg"),
      title: _t("Включенный дефект во фронтальном участке")
    }, {
      photo: require("./Photos/Включенный дефект бок.jpg"),
      title: _t("Включенный дефект в боковом участке")
    }, {
      photo: require("./Photos/Концевой дефект бок.jpg"),
      title: _t("Концевой дефект в боковом участке")
    }, {
      photo: require("./Photos/Частичная-адентия-1.jpg"),
      title: _t("Частичная адентия 1")
    }, {
      photo: require("./Photos/Частичная-адентия-2.jpg"),
      title: _t("Частичная адентия 2")
    }, {
      photo: require("./Photos/Частичная-адентия-3.jpg"),
      title: _t("Частичная адентия 3")
    }],
    vr: [{
      folder: "adentia",
      xCount: 90,
      yCount: 0,
      title: _t("Частичная адентия"),
      preview: require("./VRPacks/adentia/0_82.jpg")
    }]
  }, {
    type: "decayedTeeth",
    title: _t("Разрушенные зубы"),
    text: _t("<b>Разрушение коронковой части зуба</b> - это изменение формы и цвета коронки зуба. <br>Данное стоматологическое заболевание  может развиваться вследствие травмы, повышенной стираемости зубов, развития кариеса или пульпита. Частички пищи, налет и камень - это источники бактерий, способствующих возникновению заболеваний зубов, и как следствие, их разрушению.<br>Разрушенный зуб  - это среда для развития болезнетворных бактерий, откуда они могут распространяться по организму, что в свою очередь может привести к заболеваниям желудочно-кишечного тракта и других органов пищеварения. <br>При наличии разрушенных зубов затрудняется тщательное пережёвывание пищи, а впоследствии данная патология может повлиять и на состояние височно-нижнечелюстного сустава в целом."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.1.1-destroyed-tooth${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/decayed_tooth_video.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/decayed_tooth-preview.jpg`,
      title: _t("Разрушение коронковой части зуба")
    }],
    photo: [{
      photo: require("./Photos/decayed_tooth_1.jpg"),
      title: _t("Глубокий кариес")
    }, {
      photo: require("./Photos/decayed_tooth_2.jpg"),
      title: _t("Разрушение коронки зуба")
    }, {
      photo: require("./Photos/decayed_tooth_3.jpg"),
      title: _t("Разрушенная коронка зуба")
    }]
  }, {
    type: "prostheticsPrepare",
    title: _t("Подготовка зубов к протезированию"),
    text: _t("<b>Подготовка зубов к протезированию</b> включает в себя терапевтические и ортопедические этапы, связанные с лечением корневых каналов и создание основы для будущих коронок или виниров. Это очень важный этап, который определяет качество и долговечность использования будущей протезной конструкции. <br>При подготовке зубов к протезированию применяются такие методики как:</br><b>Пломбирование корневых каналов</b> – это процедура, которая применяется в случае удаления пульпы зуба и после очистки каналов. Очистка корневых каналов осуществляется для того, чтобы устранить накапливавшиеся в нем бактерии.<br><b>Реставрация культи зуба</b> – это реконструкция коронковой части зуба методом прямого реставрации для дальнейшей фиксации коронки.<br><b>Культевая вкладка</b> – это специально изготовленная при помощи слепка зубов конструкция, на которую в дальнейшем фиксируется искусственная коронка. Крепится она в каналах собственных корней."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.1.2-preparation-prosthetics${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Пломбировка канала.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Пломбировка канала.jpg`,
      title: _t("Пломбировка канала")
    }, {
      video: `${CDN_DOMAIN}/Videos/реставрация культи зуба.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрация культи зуба.jpg`,
      title: _t("Реставрация культи зуба")
    }, {
      video: `${CDN_DOMAIN}/Videos/культвая вкладка металл.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/культвая вкладка металл.jpg`,
      title: _t("Металлическая культевая вкладка")
    }, {
      video: `${CDN_DOMAIN}/Videos/Metal Root Tab.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Metal Root Tab.jpg`,
      title: _t("Разборная культевая вкладка")
    }],
    photo: [{
      photo: require("./Photos/rootChannels3.jpg"),
      title: _t("Пломбировка канала")
    }, {
      photo: require("./Photos/rootChannels4.jpg"),
      title: _t("Пломбировка канала")
    }, {
      photo: require("./Photos/культи зуб.jpg"),
      title: _t("Восстановление коронки зуба")
    }, {
      photo: require("./Photos/культи зуб1.jpg"),
      title: _t("Восстановление коронки зуба")
    }, {
      photo: require("./Photos/культи зуб2.jpg"),
      title: _t("Восстановление коронки зуба")
    }, {
      photo: require("./Photos/культвая вкладка металл..jpg"),
      title: _t("Металлическая культевая вкладка 46 зуб")
    }, {
      photo: require("./Photos/культвая вкладка металл.1.jpg"),
      title: _t("Металлическая культевая вкладка 46 зуб")
    }, {
      photo: require("./Photos/культвая вкладка металл2..jpg"),
      title: _t("Металлическая культевая вкладка 46 зуб")
    }, {
      photo: require("./Photos/rootTab3.jpg"),
      title: _t("Металлическая культевая вкладка 45 зуб")
    }, {
      photo: require("./Photos/rootTab4.jpg"),
      title: _t("Металлическая культевая вкладка 45 зуб")
    }, {
      photo: require("./Photos/Культивая вкладка.jpg"),
      title: _t("Разборная культевая вкладка 26 зуб")
    }, {
      photo: require("./Photos/rootTab2.jpg"),
      title: _t("Разборная культевая вкладка 26 зуб")
    }, {
      photo: require("./Photos/rootTab.jpg"),
      title: _t("Разборная культевая вкладка 26 зуб")
    }]
  }, {
    type: "implantation",
    title: _t("Имплантация"),
    text: _t("Дентальная имплантация - вживление импланта в костные ткани, для создания искусственной опоры, на которую в последующем одевается зубной протез. Зубной имплант заменяет прежний корень зуба и используется, как для замещения одного зуба, так и протезирования всех зубов на челюсти. Дентальные импланты бывают разнообразной формы и производятся большим количеством компаний. Изготавливаются изделия из специального титанового сплава. Специфичность изделия заключается в специальном покрытии, которое достигается обработкой песком и кислотами. Имплантация - это самый современный способ лечения адентии у взрослых пациентов. <br> Данная методика не требует обработки здоровых зубов и переносит всю жевательную нагрузку на кость, как и было предусмотрено природой. На сегодняшний день установка имплантов минимально травматична и практически ﻿безболезненна благодаря методике использования хирургических шаблонов. Хирургический шаблон – это капа из специального пластика, которая помогает установить имплант в максимально подходящее для него место с высокой точностью. Данное устройство является результатом цифрового планирования операции и изготавливается при помощи технологии 3D печати."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.2-implantation-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Дентальная имплантация")
    }, {
      video: `${CDN_DOMAIN}/Videos/Crown On Implant With Individual Titanium Abutment.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Crown On Implant With Individual Titanium Abutment.png`,
      title: _t("Имплантация на нижней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/Имплантация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Имплантация.png`,
      title: _t("Имплантация на верхней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/Implantaciya S Pomoshyu Hirurgicheskogo Shablona.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Implantaciya-S-Pomoshyu-Hirurgicheskogo-Shablona.png`,
      title: _t("Хирургический шаблон на верхнюю челюсть")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Пилотный Протокол-26.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Пилотный-Протокол-26.png`,
      title: _t("Хирургический шаблон, пилотный протокол")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Полный Протокол-27.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Полный-Протокол-27.png`,
      title: _t("Хирургический шаблон, полный протокол")
    }],
    photo: [{
      photo: require("./Photos/Фото1_yXMoWOU.jpg"),
      title: _t("Имплантация 21 зуб")
    }, {
      photo: require("./Photos/Фото2_v0Hu4WI.jpg"),
      title: _t("Имплантация 45 зуб")
    }, {
      photo: require("./Photos/Фото4_bzw7oGH.jpg"),
      title: _t("Имплантация 46 зуб")
    }, {
      photo: require("./Photos/Фото4_1cuZIzf.jpg"),
      title: _t("Имплантация 45-46 зуб")
    }, {
      photo: require("./Photos/Фото7_vxsKpiR.jpg"),
      title: _t("Имплантация 25 зуб")
    }, {
      photo: require("./Photos/шаблон.jpg"),
      title: _t("Имплантация через хирургический шаблон")
    }, {
      photo: require("./Photos/шаблон3.jpg"),
      title: _t("Хирургический шаблон")
    }, {
      photo: require("./Photos/Фото_v4FA9Mb.jpg"),
      title: _t("Хирургический шаблон на 6 имплантов")
    }, {
      photo: require("./Photos/Фото9_DqA0bXI.jpg"),
      title: _t("Хирургический шаблон 14 зуб")
    }, {
      photo: require("./Photos/Фото10_CZEVBLq.jpg"),
      title: _t("Протез с имплантом на модели")
    }],
    vr: [{
      folder: "Circon_abutment",
      xCount: 105,
      yCount: 0,
      title: _t("Имплант в области центрального зуба"),
      preview: require("./VRPacks/Circon_abutment/0_1.jpg")
    }, {
      folder: "Titan_abutment_46",
      xCount: 89,
      yCount: 0,
      title: _t("Имплант в области жевательного зуба"),
      preview: require("./VRPacks/Titan_abutment_46/0_1.jpg")
    }, {
      folder: "multiunit_44-46",
      xCount: 91,
      yCount: 0,
      title: _t("Импланты в боковом участке"),
      preview: require("./VRPacks/multiunit_44-46/0_1.jpg")
    }]
  }, {
    type: "fixedProsthetics",
    title: _t("Несъемное протезирование"),
    text: _t("Несъемное протезирование - это возмещение недостающих зубов мостовидными протезами. Данная методика требует обработки соседних зубов рядом с отсутствующими зубами. Во время препаровки зубов снимается более 1 мм тканей зуба со всех сторон. При использовании мостовидных протезов жевательная нагрузка с искусственных зубов переносится на опорные зубы моста. <br> В настоящее время мостовидные несъемные протезы изготавливаются из металлокерамики, диоксида циркония, а также используются комбинированные конструкции из диоксида циркония с керамической облицовкой. <br> Диоксид циркония самый современный материал для изготовления мостовидных протезов. Он обладает двумя необходимыми качествами: прочность и эстетичность. Одна из модификаций диоксида циркония, мультислойный циркон, является максимально эстетичной благодаря градации по цвету и прозрачности от шейки зуба до режущего края. Специальные краски позволяют индивидуализировать протезы и делать их максимально похожими на естественные зубы."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.3-bridge-prosthetics${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Bridges Of Zirconium.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Bridges-Of-Zirconium.png`,
      title: "Зубной мост на передние зубы"
    }, {
      video: `${CDN_DOMAIN}/Videos/Мост подкова Colleagial.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Мост подкова Colleagial.jpg`,
      title: "Мост подкова"
    }, {
      video: `${CDN_DOMAIN}/Videos/The Bridge Of Dental Zirconium.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/The Bridge Of Dental Zirconium.png`,
      title: _t("Зубной мост на жевательные зубы")
    }, {
      video: `${CDN_DOMAIN}/Videos/Dental Adhesive Bridge.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Dental-Adhesive-Bridge.png`,
      title: _t("Временный съемный протез")
    }],
    photo: [{
      photo: require("./Photos/Фото5_1XB0pW7.jpg"),
      title: _t("Мост из диоксида циркония")
    }, {
      photo: require("./Photos/Фото8.jpg"),
      title: _t("Мост на жевательные зубы")
    }, {
      photo: require("./Photos/Фото6.jpg"),
      title: _t("Мост на передние зубы")
    }, {
      photo: require("./Photos/Фото4_SE3ZK9W.jpg"),
      title: _t("Адгезивный мост")
    }, {
      photo: require("./Photos/Фото7.jpg"),
      title: _t("Металлокерамический мост")
    }, {
      photo: require("./Photos/Фото.jpg"),
      title: _t("Мосты на жевательные зубы")
    }],
    vr: [{
      folder: "brige",
      xCount: 90,
      yCount: 0,
      title: _t("Мостовидный протез на фронтальные зубы"),
      preview: require("./VRPacks/brige/0_6.jpg")
    }, {
      folder: "bridgePasterior",
      xCount: 90,
      yCount: 0,
      title: _t("Мостовидный протез на боковые зубы"),
      preview: require("./VRPacks/bridgePasterior/0_16.jpg")
    }]
  }, {
    type: "removableProsthetics",
    title: _t("Съемное протезирование"),
    text: _t("Съемное протезирование - это возмещение недостающих зубов при помощи съемных зубных протезов, которые состоят из искусственной десны, пластиковых зубов и фиксирующих элементов. Съемные зубные протезы способны возмещать любое количество зубов на челюсти, от одного до всех. Широко применяются микропротезы на один или два зуба. <br> ВНИМАНИЕ! Данные протезы всю жевательную нагрузку переносят на десну, что крайне нежелательно для здоровья десны и кости под базисом протеза. По этой причине съемные протезы используются только временно. Съемные зубные протезы изготавливаются из специальных пластиков. Основные материалы, из которых изготавливаются базисы протезов это: акрил или нейлон, а также широко используются комбинированные конструкции с металлическим базисом. Каждый из них обладает своими преимуществами и недостатками, но стоит учитывать, что долговечность конструкции не имеет большого значения на фоне необратимых процессов убыли кости и десны, которые происходят после длительного ношения протезов с опорой на слизистую. Минимизировать нежелательный эффект можно только создав опору на естественные зубы, аттачменты или телескопические коронки."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.4-removable-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Dental Microprosthesis Removable.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Dental Microprosthesis Removable.png`,
      title: _t("Временный микропротез")
    }, {
      video: `${CDN_DOMAIN}/Videos/Съемные.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Съемные.jpg`,
      title: _t("Временный микропротез")
    }, {
      video: `${CDN_DOMAIN}/Videos/Nylon Prosthesis.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Nylon-Prosthesis.png`,
      title: _t("Временный нейлоновый протез")
    }, {
      video: `${CDN_DOMAIN}/Videos/Prosthesis On Telescopic Crowns.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Prosthesis-On-Telescopic-Crowns.png`,
      title: _t("Протез на телескопических коронках")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable Prosthesis Fixation On The Beam.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable-Prosthesis-Fixation-On-The-Beam.png`,
      title: _t("Протез с фиксацией на балках")
    }, {
      video: `${CDN_DOMAIN}/Videos/Attachments.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Attachments.png`,
      title: _t("Протез с фиксацией на аттачментах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Akril_1_0.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Akril_1_0.jpg`,
      title: _t("Протез с фиксацией на кламмерах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Akril_2_0.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Akril_2_0.png`,
      title: _t("Протез с фиксацией на кламмерах 2")
    }],
    photo: [{
      photo: require("./Photos/Mikro_prothrsis.jpg"),
      title: _t("Микропротез 11 зуб")
    }, {
      photo: require("./Photos/Фото3_HZ6YokS.jpg"),
      title: _t("Нейлоновый протез")
    }, {
      photo: require("./Photos/Фото3_aPbFYpa.jpg"),
      title: _t("Частичный съемный протез")
    }, {
      photo: require("./Photos/Фото1_MThM8i1.jpg"),
      title: _t("Съемный протез на челюсти")
    }, {
      photo: require("./Photos/Фото3_3FW9EL6.jpg"),
      title: _t("Протез на телескопических коронках")
    }, {
      photo: require("./Photos/Фото3_mJwxwnN.jpg"),
      title: _t("Протез с фиксацией на аттачментах")
    }, {
      photo: require("./Photos/Фото5_ao9ptHy.jpg"),
      title: _t("Съемные протезы")
    }, {
      photo: require("./Photos/Фото7_2u1GCuo.jpg"),
      title: _t("Протез с фиксацией на аттачментах 2")
    }],
    vr: [{
      folder: "Bugel_metal",
      xCount: 90,
      yCount: 0,
      title: _t("Бюгельный протез"),
      preview: require("./VRPacks/Bugel_metal/0_31.jpg")
    }, {
      folder: "Neilon_prot",
      xCount: 90,
      yCount: 0,
      title: _t("Нейлоновый протез"),
      preview: require("./VRPacks/Neilon_prot/0_31.jpg")
    }, {
      folder: "partialAcrylicDenture",
      xCount: 90,
      yCount: 0,
      title: _t("Акриловый пластинчатый протез"),
      preview: require("./VRPacks/partialAcrylicDenture/0_17.jpg")
    }, {
      folder: "bug_attach",
      xCount: 86,
      yCount: 0,
      title: _t("Протез на аттачментах"),
      preview: require("./VRPacks/bug_attach/0_31.jpg")
    }, {
      folder: "bugelonBims",
      xCount: 90,
      yCount: 0,
      title: _t("Протез на балках"),
      preview: require("./VRPacks/bugelonBims/0_31.jpg")
    }, {
      folder: "microprosthesis",
      xCount: 90,
      yCount: 0,
      title: _t("Съемный микропротез"),
      preview: require("./VRPacks/microprosthesis/0_31.jpg")
    }]
  }, {
    type: "implantPosition",
    title: _t("Дентальная имплантация"),
    text: _t("<b>Дентальная имплантация</b> - вживление импланта в костные ткани, для создания искусственной опоры, на которую в последующем одевается зубной протез. Зубной имплант заменяет прежний корень зуба и используется, как для замещения одного зуба, так и протезирования всех зубов на челюсти. <br> <b>Правила: </b> Импланты необходимо устанавливать в области отсутствующих зубов. Один имплант может нести на себе нагрузку соседнего зуба. Соответственно между имплантами может быть 1 или максимум 2 подвесных зуба."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.5-implants-installation${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Дентальная имплантация")
    }, {
      video: `${CDN_DOMAIN}/Videos/Crown On Implant With Individual Titanium Abutment.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Crown On Implant With Individual Titanium Abutment.png`,
      title: _t("Имплантация на нижней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/Имплантация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Имплантация.png`,
      title: _t("Имплантация на верхней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/Implantaciya S Pomoshyu Hirurgicheskogo Shablona.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Implantaciya-S-Pomoshyu-Hirurgicheskogo-Shablona.png`,
      title: _t("Хирургический шаблон на верхнюю челюсть")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Пилотный Протокол-26.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Пилотный-Протокол-26.png`,
      title: _t("Хирургический шаблон, пилотный протокол")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Полный Протокол-27.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Полный-Протокол-27.png`,
      title: _t("Хирургический шаблон, полный протокол")
    }],
    photo: [{
      photo: require("./Photos/Фото1_yXMoWOU.jpg"),
      title: _t("Имплантация 21 зуб")
    }, {
      photo: require("./Photos/Фото2_v0Hu4WI.jpg"),
      title: _t("Имплантация 45 зуб")
    }, {
      photo: require("./Photos/Фото4_bzw7oGH.jpg"),
      title: _t("Имплантация 46 зуб")
    }, {
      photo: require("./Photos/Фото4_1cuZIzf.jpg"),
      title: _t("Имплантация 45-46 зуб")
    }, {
      photo: require("./Photos/Фото7_vxsKpiR.jpg"),
      title: _t("Имплантация 25 зуб")
    }, {
      photo: require("./Photos/шаблон.jpg"),
      title: _t("Имплантация через хирургический шаблон")
    }, {
      photo: require("./Photos/шаблон3.jpg"),
      title: _t("Хирургический шаблон")
    }, {
      photo: require("./Photos/Фото_v4FA9Mb.jpg"),
      title: _t("Хирургический шаблон на 6 имплантов")
    }, {
      photo: require("./Photos/Фото9_DqA0bXI.jpg"),
      title: _t("Хирургический шаблон 14 зуб")
    }, {
      photo: require("./Photos/Фото10_CZEVBLq.jpg"),
      title: _t("Протез с имплантом на модели")
    }, {
      photo: require("./Photos/Фото10_CZEVBLq1.jpg"),
      title: _t("Зуб на импланте")
    }],
    vr: [{
      folder: "Circon_abutment",
      xCount: 105,
      yCount: 0,
      title: _t("Имплант в области центрального зуба"),
      preview: require("./VRPacks/Circon_abutment/0_1.jpg")
    }, {
      folder: "Titan_abutment_46",
      xCount: 89,
      yCount: 0,
      title: _t("Имплант в области жевательного зуба"),
      preview: require("./VRPacks/Titan_abutment_46/0_1.jpg")
    }, {
      folder: "multiunit_44-46",
      xCount: 91,
      yCount: 0,
      title: _t("Импланты в боковом участке"),
      preview: require("./VRPacks/multiunit_44-46/0_1.jpg")
    }]
  }, {
    type: "screwFixation",
    title: _t("Винтовая фиксация протеза к импланту"),
    text: _t("Винтовая фиксация протеза к импланту - одна из самых практичных и эстетичных методик. Протез прикручивается к импланту при помощи специального винта через отверстие в коронке (шахту), после чего отверстие закрывается композитной пломбой. Данная методика простая и удобная. Ее называют условно-съемным протезированием, потому что она позволяет в любой момент снять конструкцию не повредив и также успешно установить обратно. Это позволяет обслуживать протез и производить профессиональную гигиену полости рта. Недостаток: такие конструкции нельзя использовать при не параллельной установке имплантов. Чаще всего используется для одиночных коронок и небольших мостов."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.16-skrew-fixation-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Винтовая фиксация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая фиксация.jpg`,
      title: _t("Коронки винтовой фиксации")
    }, {
      video: `${CDN_DOMAIN}/Videos/46_Винтовая_Фиксация-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/46_Винтовая_Фиксация-1.png`,
      title: _t("Коронка винтовой фиксации")
    }, {
      video: `${CDN_DOMAIN}/Videos/Crowns_On_Screw_Fixation_Implant.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Crowns_On_Screw_Fixation_Implant.png`,
      title: _t("Коронка винтовой фиксации на 36 зуб")
    }, {
      video: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.png`,
      title: _t("Временный протез винтовой фиксации")
    }],
    photo: [{
      photo: require("./Photos/Винтовая фикс 1.jpg"),
      title: _t("Коронка винтовой фиксации на 46 зуб")
    }, {
      photo: require("./Photos/Винтовая фикс 2.jpg"),
      title: _t("Шахта коронки винтовой фиксации")
    }, {
      photo: require("./Photos/Винтовая фикс 3.jpg"),
      title: _t("Коронка винтовой фиксации")
    }, {
      photo: require("./Photos/Винтовая фикс 4.jpg"),
      title: _t("Коронка винтовой фиксации 2")
    }, {
      photo: require("./Photos/Винтовая фикс 5.jpg"),
      title: _t("Мост винтовой фиксации")
    }],
    vr: [{
      folder: "Skrew_fixation_11-21",
      xCount: 90,
      yCount: 0,
      title: _t("Винтовая фиксация коронок к импланту"),
      preview: require("./VRPacks/Skrew_fixation_11-21/0_4.jpg")
    }, {
      folder: "Titan_abutment_46",
      xCount: 89,
      yCount: 0,
      title: _t("Винтовая фиксация"),
      preview: require("./VRPacks/Titan_abutment_46/0_1.jpg")
    }]
  }, {
    type: "cementFixation",
    title: _t("Цементная фиксация протеза к импланту"),
    text: _t("Цементная фиксация протеза к импланту - производится при помощи абатмента (специальная головка, которая прикручивается винтом к импланту). Абатмент формирует наддесневую часть конструкции, на которую крепится протез при помощи стоматологического цемента. Абатменты, в свою очередь, бывают стандартными и индивидуальными. Индивидуальные металлические и циркониевые абатменты выгодно отличаются от стандартных тем, что они помогают формировать десну вокруг импланта и обеспечивают лучшую эстетику мягких тканей."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.13-cement-fixation-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Абатмент стандартный 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент стандартный 1.png`,
      title: _t("Абатмент стандартный")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент стандартный 2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент стандартный 2.png`,
      title: _t("Коронка на стандартном абатменте")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент стандартный 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент стандартный 3.png`,
      title: _t("Мост на стандартных абатментах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 1.png`,
      title: _t("Абатмент титановый")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 2.png`,
      title: _t("Коронка на титановом абатменте")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Мост на титановых абатментах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент цирконевый 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент цирконевый 1.png`,
      title: _t("Абатмент циркониевый")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент цирконевый 2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент цирконевый 2.png`,
      title: _t("Коронка на циркониевом абатменте")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент цирконевый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент цирконевый 3.png`,
      title: _t("Мост на циркониевых абатментах")
    }],
    photo: [{
      photo: require("./Photos/Абатмент стандартный фото 1.jpg"),
      title: _t("Абатмент стандартный")
    }, {
      photo: require("./Photos/Абатмент стандартный фото 2.jpg"),
      title: _t("Коронка на стандартном абатменте")
    }, {
      photo: require("./Photos/Абатмент стандартный фото 3.jpg"),
      title: _t("Абатмент стандартный с винтом")
    }, {
      photo: require("./Photos/Абатмент титановый фото 1.jpg"),
      title: _t("Абатмент титановый")
    }, {
      photo: require("./Photos/Абатмент титановый фото 2.jpg"),
      title: _t("Коронка на титановом абатменте")
    }, {
      photo: require("./Photos/Абатмент титановый фото 3.jpg"),
      title: _t("Абатмент титановый с коронкой и винтом")
    }, {
      photo: require("./Photos/Абатмент цирконевый фото 1.jpg"),
      title: _t("Абатменты циркониевые")
    }, {
      photo: require("./Photos/Абатмент цирконевый фото 2.jpg"),
      title: _t("Абатмент циркониевый с коронкой")
    }, {
      photo: require("./Photos/Абатмент цирконевый фото 3.jpg"),
      title: _t("Абатмент циркониевый")
    }],
    vr: [{
      folder: "Circon_abutment",
      xCount: 105,
      yCount: 0,
      title: _t("Цирконевый абатмент"),
      preview: require("./VRPacks/Circon_abutment/0_1.jpg")
    }, {
      folder: "Titan_abutment_46",
      xCount: 89,
      yCount: 0,
      title: _t("Титановый абатмент"),
      preview: require("./VRPacks/Titan_abutment_46/0_1.jpg")
    }, {
      folder: "Titan_abutment_21",
      xCount: 90,
      yCount: 0,
      title: _t("Индивидуальный титановый абатмент"),
      preview: require("./VRPacks/Titan_abutment_21/0_17.jpg")
    }, {
      folder: "Circon_abutment_45",
      xCount: 90,
      yCount: 0,
      title: _t("Цельноцерконевый абатмент"),
      preview: require("./VRPacks/Circon_abutment_45/0_6.jpg")
    }, {
      folder: "Standart_abutment",
      xCount: 89,
      yCount: 0,
      title: _t("Стандартный абатмент"),
      preview: require("./VRPacks/Standart_abutment/0_12.jpg")
    }]
  }, {
    type: "multiunutFixation",
    title: _t("Фиксация на мульти-юнитах"),
    text: _t("Винтовая фиксация протеза к импланту с использованием мульти-юнит абатмента - одна из самых надежных и практичных систем. Мульти-юнит - это переходник при помощи которого можно использовать все преимущества системы винтовой фиксации, но при этом ее применение не ограничивается случаями с не параллельным расположением имплантов в кости. Используется для протезов большой протяженности, для мостов на всю челюсть. Не используются для одиночных коронок."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.14-multiunit-fixation-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Протез на мульти-юнитах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.png`,
      title: _t("Протез на мульти-юнитах Owerpress")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 2.png`,
      title: _t("Мост на мульти-юнитах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Гингива Импланты.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Гингива Импланты.jpg`,
      title: _t("Пластика десны при использовании мульти-юнитов")
    }],
    photo: [{
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Протез на мульти-юнитах")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 2.jpg"),
      title: _t("Протез на мульти-юнитах")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 3.jpg"),
      title: _t("Протез на мульти-юнитах")
    }, {
      photo: require("./Photos/Гингива импланты.5515.jpg"),
      title: _t("Формирование десны")
    }, {
      photo: require("./Photos/Гингива импланты.5516.jpg"),
      title: _t("Супраструктура")
    }, {
      photo: require("./Photos/Гингива импланты.5518.jpg"),
      title: _t("Коронки на супраструктуре")
    }],
    vr: [{
      folder: "multiunit_44-46",
      xCount: 91,
      yCount: 0,
      title: _t("Фиксация протеза на мульти-юнитах"),
      preview: require("./VRPacks/multiunit_44-46/0_1.jpg")
    }, {
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }]
  }, {
    type: "implantationSelectFalseTeeth",
    title: _t("Подвесной зуб"),
    text: _t("<b>Подвесной зуб</b> - это искусственный зуб, замещающий отсутствующий в мостовидном протезе на имплантах или на опорных зубах. Подвесной зуб имеет промывную зону, которая прилегает к десне. Различаются типы подвесных зубов по форме промывной зоны. Она может быть такой, что искусственный зуб только слегка касается десны, а может охватывать зуб значительной поверхностью. <br> С точки зрения удобства, зуб который плотно ложится на десну более удобный, но с другой стороны такая форма промыва не позволяет тщательно вычищать протез со стороны опоры на десну. Форма промыва выбирается исходя из состояния и формы десны, а также отталкиваясь от гигиенического состояния полости рта пациента. <br> Принято считать, что один имплант может нести на себе нагрузку одного подвесного зуба. Соответственно между имплантами может находиться один или максимум 2 подвесных зуба. Если у Вас получилось больше, в таком случае вернитесь на пару шагов назад и установите дополнительные импланты."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.6-hanging-teeth-impl${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Подвесные зубы.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Подвесные-зубы.png`,
      title: _t("Подвесные зубы")
    }],
    photo: [{
      photo: require("./Photos/Подвесные зубы 1.jpg"),
      title: _t("Подвесные зубы")
    }, {
      photo: require("./Photos/Подвесные зубы 2.jpg"),
      title: _t("Подвесные зубы")
    }, {
      photo: require("./Photos/Подвесные зубы 3.jpg"),
      title: _t("Подвесные зубы")
    }]
  }, {
    type: "implantationSelectFalseTeethConnection",
    title: _t("Соединения"),
    text: _t("<b>Соединения между подвесными зубами и коронками на имплантах (коннекторы)</b> - конструкционные решения, необходимые для создания целостности протезной конструкции. Благодаря коннекторам жевательная нагрузка распределяется по всей протяженности моста и переносится на опорные импланты. <br> Коннекторы необходимо ставить во всех местах, где подвесные зубы соединяются друг с другом или с коронками. Коронки также соединяются коннекторами при возможности. Чем более цельной будет конструкция на имплантах, тем более долговечной и стабильной она будет. Не соединяются коронки только в случаях, когда абатменты расположены не параллельно."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.7-connections-impl${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Соединения-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Соединения-1.png`,
      title: _t("Соединения в мосте на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Соединения-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Соединения-1.jpg`,
      title: "Соединения"
    }],
    photo: [{
      photo: require("./Photos/Соединения 1.jpg"),
      title: _t("Соединения в мосте на имплантах")
    }, {
      photo: require("./Photos/Соединения 2.jpg"),
      title: _t("Соединения в мосте на имплантах")
    }, {
      photo: require("./Photos/Соединения 3.jpg"),
      title: _t("Соединения в мосте на имплантах")
    }]
  }, {
    type: "adentyTopImplant",
    title: _t("Протез на имплантах"),
    text: _t("<b>Дентальная имплантация</b> - вживление импланта в костные ткани, для создания искусственной опоры, на которую в последующем одевается зубной протез. Зубной имплант заменяет прежний корень зуба и используется, как для замещения одного зуба, так и протезирования всех зубов на челюсти. Импланты изготавливаются из специального титанового сплава. Специфичность изделия заключается в специальном покрытии, которое достигается обработкой песком и кислотами. Имплантация применяется в большинстве случаев с полной адентией. Данная методика признана самым надежный и высоко эстетический способ протезирования беззубых челюстей. Протезы на имплантах способны восстановить жевательную функцию до 100%. <br> В настоящее время операция по установке дентальных имплантов не занимает много времени и является минимально травматичной, а также может быть абсолютно безболезненной при использовании современных способов анастезии. Срок реабилитации минимальный, во многих случаях пациент после операции уже может покинуть кабинет врача с зубами и начинать пережевывать не твердую пищу в ближайшие дни. Прогнозируемость операции увеличивает использование цифровых методик планирования и хирургических шаблонов. Данный подход позволяет создавать протезные конструкции для немедленной нагрузки, то есть временный эстетичный протез, который пациент может получить в день имплантации или в ближайшие дни, в зависимости от условий."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.1-implantation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Тотальный протез на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.png`,
      title: _t("Протез на мульти-юнитах Owerpress")
    }, {
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants_iy2iBaK.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants.png`,
      title: _t("Протезы на имплантах")
    }],
    photo: [{
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 3.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL1s.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL2s.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL3s.jpg"),
      title: _t("Протез на имплантах")
    }],
    vr: [{
      folder: "Total_multiunit_low",
      xCount: 107,
      yCount: 0,
      title: _t("Полный съемный протез на имплантах"),
      preview: require("./VRPacks/Total_multiunit_low/0_107.jpg")
    }, {
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }, {
      folder: "Circon_abutment_total",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Circon_abutment_total/0_32.jpg")
    }]
  }, {
    type: "adentyTopGum",
    title: _t("Съемный протез"),
    text: _t("<b>Полные съемные протезы</b> устанавливают при полной адентии (первичной или вторичной). Они опираются лишь на альвеолярные отростки челюстей, а на верхней челюсти дополнительным креплением выступает небо. Основным преимуществом данного типа протезов является гигиена. Съемный протез легко извлечь из полости рта и произвести качественную чистку. Основной материал из которого изготавливаются протезы является акриловая пластмасса (PMMA). Этот пластик позволяет создавать высокую эстетику как в области десны, так и на искусственных зубах. <br> Полные съемные протезы восстанавливают жевательную функцию до 70%. До появления дентальной имплантации полные съемные протезы являлись основным видом протезирования беззубых челюстей, но сегодня доказано, что данные протезы можно использовать только временно, потому что слизистая не способна нести на себе нагрузку жевания. Из-за постоянного давления десна перестает нужным образом питаться кровью и начинает истончаться, а вместе с ней происходит убыль кости в месте опоры. Это приводит к потере фиксации протеза, а что самое худшее, усложняет дальнейшее протезирование на имплантах. В большинстве случаев требуется наращивание кости перед имплантацией после долговременного использования съемных протезов."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.2-removable-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Complete Removable Dentures.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Complete-Removable-Dentures.png`,
      title: _t("Съемные протезу на беззубую челюсть")
    }],
    photo: [{
      photo: require("./Photos/Полный Съемный протез.jpg"),
      title: _t("Полные съемные протезы")
    }, {
      photo: require("./Photos/Полный Съемный протез 3.jpg"),
      title: _t("Полный съемный протез")
    }, {
      photo: require("./Photos/Полный Съемный протез 2.jpg"),
      title: _t("Полные съемные протезы")
    }],
    vr: [{
      folder: "completeRemovableDenture",
      xCount: 90,
      yCount: 0,
      title: _t("Полный съемный протез"),
      preview: require("./VRPacks/completeRemovableDenture/0_56.jpg")
    }]
  }, {
    type: "adentyBottomImplant",
    title: _t("Протез на имплантах"),
    text: _t("<b>Дентальная имплантация</b> - вживление импланта в костные ткани, для создания искусственной опоры, на которую в последующем одевается зубной протез. Зубной имплант заменяет прежний корень зуба и используется, как для замещения одного зуба, так и протезирования всех зубов на челюсти. Импланты изготавливаются из специального титанового сплава. Специфичность изделия заключается в специальном покрытии, которое достигается обработкой песком и кислотами. Имплантация применяется в большинстве случаев с полной адентией. Данная методика признана самым надежный и высоко эстетический способ протезирования беззубых челюстей. Протезы на имплантах способны восстановить жевательную функцию до 100%. <br> В настоящее время операция по установке дентальных имплантов не занимает много времени и является минимально травматичной, а также может быть абсолютно безболезненной при использовании современных способов анастезии. Срок реабилитации минимальный, во многих случаях пациент после операции уже может покинуть кабинет врача с зубами и начинать пережевывать не твердую пищу в ближайшие дни. Прогнозируемость операции увеличивает использование цифровых методик планирования и хирургических шаблонов. Данный подход позволяет создавать протезные конструкции для немедленной нагрузки, то есть временный эстетичный протез, который пациент может получить в день имплантации или в ближайшие дни, в зависимости от условий."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.1-implantation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Тотальный протез на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.png`,
      title: _t("Протез на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants_iy2iBaK.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants.png`,
      title: _t("Протезы на имплантах")
    }],
    photo: [{
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 3.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL1s.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL2s.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL3s.jpg"),
      title: _t("Протез на имплантах")
    }],
    vr: [{
      folder: "Total_multiunit_low",
      xCount: 107,
      yCount: 0,
      title: _t("Полный съемный протез на имплантах"),
      preview: require("./VRPacks/Total_multiunit_low/0_107.jpg")
    }, {
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }, {
      folder: "Circon_abutment_total",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Circon_abutment_total/0_32.jpg")
    }]
  }, {
    type: "adentyBottomGum",
    title: _t("Съемный протез"),
    text: _t("<b>Полные съемные протезы</b> устанавливают при полной адентии (первичной или вторичной). Они опираются лишь на альвеолярные отростки челюстей, а на верхней челюсти дополнительным креплением выступает небо. Основным преимуществом данного типа протезов является гигиена. Съемный протез легко извлечь из полости рта и произвести качественную чистку. Основной материал из которого изготавливаются протезы является акриловая пластмасса (PMMA). Этот пластик позволяет создавать высокую эстетику как в области десны, так и на искусственных зубах. <br> Полные съемные протезы восстанавливают жевательную функцию до 70%. До появления дентальной имплантации полные съемные протезы являлись основным видом протезирования беззубых челюстей, но сегодня доказано, что данные протезы можно использовать только временно, потому что слизистая не способна нести на себе нагрузку жевания. Из-за постоянного давления десна перестает нужным образом питаться кровью и начинает истончаться, а вместе с ней происходит убыль кости в месте опоры. Это приводит к потере фиксации протеза, а что самое худшее, усложняет дальнейшее протезирование на имплантах. В большинстве случаев требуется наращивание кости перед имплантацией после долговременного использования съемных протезов."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.2-removable-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Complete Removable Dentures.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Complete-Removable-Dentures.png`,
      title: _t("Съемные протезу на беззубую челюсть")
    }],
    photo: [{
      photo: require("./Photos/Полный Съемный протез.jpg"),
      title: _t("Полные съемные протезы")
    }, {
      photo: require("./Photos/Полный Съемный протез 3.jpg"),
      title: _t("Полный съемный протез")
    }, {
      photo: require("./Photos/Полный Съемный протез 2.jpg"),
      title: _t("Полные съемные протезы")
    }],
    vr: [{
      folder: "completeRemovableDenture",
      xCount: 90,
      yCount: 0,
      title: _t("Полный съемный протез"),
      preview: require("./VRPacks/completeRemovableDenture/0_56.jpg")
    }]
  }, {
    type: "adentyBothImplant",
    title: _t("Протез на имплантах"),
    text: _t("<b>Дентальная имплантация</b> - вживление импланта в костные ткани, для создания искусственной опоры, на которую в последующем одевается зубной протез. Зубной имплант заменяет прежний корень зуба и используется, как для замещения одного зуба, так и протезирования всех зубов на челюсти. Импланты изготавливаются из специального титанового сплава. Специфичность изделия заключается в специальном покрытии, которое достигается обработкой песком и кислотами. Имплантация применяется в большинстве случаев с полной адентией. Данная методика признана самым надежный и высоко эстетический способ протезирования беззубых челюстей. Протезы на имплантах способны восстановить жевательную функцию до 100%. <br> В настоящее время операция по установке дентальных имплантов не занимает много времени и является минимально травматичной, а также может быть абсолютно безболезненной при использовании современных способов анастезии. Срок реабилитации минимальный, во многих случаях пациент после операции уже может покинуть кабинет врача с зубами и начинать пережевывать не твердую пищу в ближайшие дни. Прогнозируемость операции увеличивает использование цифровых методик планирования и хирургических шаблонов. Данный подход позволяет создавать протезные конструкции для немедленной нагрузки, то есть временный эстетичный протез, который пациент может получить в день имплантации или в ближайшие дни, в зависимости от условий."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.1-implantation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Тотальный протез на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.png`,
      title: _t("Протез на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants_iy2iBaK.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants.png`,
      title: _t("Протезы на имплантах")
    }],
    photo: [{
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 3.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL1s.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL2s.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL3s.jpg"),
      title: _t("Протез на имплантах")
    }],
    vr: [{
      folder: "Total_multiunit_low",
      xCount: 107,
      yCount: 0,
      title: _t("Полный съемный протез на имплантах"),
      preview: require("./VRPacks/Total_multiunit_low/0_107.jpg")
    }, {
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }, {
      folder: "Circon_abutment_total",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Circon_abutment_total/0_32.jpg")
    }]
  }, {
    type: "adentyBothGum",
    title: _t("Съемный протез"),
    text: _t("<b>Полные съемные протезы</b> устанавливают при полной адентии (первичной или вторичной). Они опираются лишь на альвеолярные отростки челюстей, а на верхней челюсти дополнительным креплением выступает небо. Основным преимуществом данного типа протезов является гигиена. Съемный протез легко извлечь из полости рта и произвести качественную чистку. Основной материал из которого изготавливаются протезы является акриловая пластмасса (PMMA). Этот пластик позволяет создавать высокую эстетику как в области десны, так и на искусственных зубах. <br> Полные съемные протезы восстанавливают жевательную функцию до 70%. До появления дентальной имплантации полные съемные протезы являлись основным видом протезирования беззубых челюстей, но сегодня доказано, что данные протезы можно использовать только временно, потому что слизистая не способна нести на себе нагрузку жевания. Из-за постоянного давления десна перестает нужным образом питаться кровью и начинает истончаться, а вместе с ней происходит убыль кости в месте опоры. Это приводит к потере фиксации протеза, а что самое худшее, усложняет дальнейшее протезирование на имплантах. В большинстве случаев требуется наращивание кости перед имплантацией после долговременного использования съемных протезов."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.2-removable-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Complete Removable Dentures.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Complete-Removable-Dentures.png`,
      title: _t("Съемные протезу на беззубую челюсть")
    }],
    photo: [{
      photo: require("./Photos/Полный Съемный протез.jpg"),
      title: _t("Полные съемные протезы")
    }, {
      photo: require("./Photos/Полный Съемный протез 3.jpg"),
      title: _t("Полный съемный протез")
    }, {
      photo: require("./Photos/Полный Съемный протез 2.jpg"),
      title: _t("Полные съемные протезы")
    }],
    vr: [{
      folder: "completeRemovableDenture",
      xCount: 90,
      yCount: 0,
      title: _t("Полный съемный протез"),
      preview: require("./VRPacks/completeRemovableDenture/0_56.jpg")
    }]
  }, {
    type: "adentyImplantProsthesisFixation_adentyTopImplant",
    title: _t("Установка имплантов на верхней челюсти"),
    text: _t('Существуют 2 основных типа расстановки имплантов на беззубые челюсти: "Все на четырех" (All on four) и "Все на шести" (All on six). <br> "Все на шести" подразумевает позиционирование имплантов в области 2-ых,4-ых и 6-ых зубов в каждом сегменте. <br> "Все на четырех" подразумевает позиционирование имплантов в области 2-ых, 5-ых зубов в каждом сегменте. <br> Использование 6 имплантов на челюсти для создания опоры для протеза более надежный подход к протезированию, но во многих случаях используется 4 импланта на челюсти из-за недостатка кости. Часто недостаток кости, в которой должен фиксироваться имплант, может быть достаточно большой из-за долгого отсутствия зубов на челюсти, из-за использования съемного протеза долгий промежуток времени или после сложных удалений зубов. Концепция изготовления протезов на 6-и имплантах позволяет включать в протез 12 - 14 зубов, что восстанавливает жевательную функцию почти полностью. <br> Несъемные и условно - съемные протезы на четырех имплантах могут быть изготовлены максимум на 10 зубов и способны восстановить функцию жевания не более, чем на 70%.'),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.3-implants-installation-full${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Все на шести")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Все на четырех")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Все на четырех")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Протез цементной фиксации на шести имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants_iy2iBaK.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants.png`,
      title: _t("Съемный протез на четырех имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.png`,
      title: _t("Условно съемный протез на шести имплантах")
    }],
    photo: [{
      photo: require("./Photos/Фото8_mhANL1s.jpg"),
      title: _t("Все на шести")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Фото8_mhANL2s.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 2.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Фото8_mhANL3s.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 3.jpg"),
      title: _t("Все на четырех")
    }],
    vr: [{
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }, {
      folder: "Circon_abutment_total",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Circon_abutment_total/0_32.jpg")
    }]
  }, {
    type: "adentyImplantProsthesisFixation_adentyBottomImplant",
    title: _t("Установка имплантов на нижнюю челюсти"),
    text: _t('Существуют 2 основных типа расстановки имплантов на беззубые челюсти: "Все на четырех" (All on four) и "Все на шести" (All on six). <br> "Все на шести" подразумевает позиционирование имплантов в области 2-ых,4-ых и 6-ых зубов в каждом сегменте. <br> "Все на четырех" подразумевает позиционирование имплантов в области 2-ых, 5-ых зубов в каждом сегменте. <br> Использование 6 имплантов на челюсти для создания опоры для протеза более надежный подход к протезированию, но во многих случаях используется 4 импланта на челюсти из-за недостатка кости. Часто недостаток кости, в которой должен фиксироваться имплант, может быть достаточно большой из-за долгого отсутствия зубов на челюсти, из-за использования съемного протеза долгий промежуток времени или после сложных удалений зубов. <br> Концепция изготовления протезов на 6-и имплантах позволяет включать в протез 12 - 14 зубов, что восстанавливает жевательную функцию почти полностью. Несъемные и условно - съемные протезы на четырех имплантах могут быть изготовлены максимум на 10 зубов и способны восстановить функцию жевания не более, чем на 70%.'),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.3-implants-installation-full${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Все на шести")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Все на четырех")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Все на четырех")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Протез цементной фиксации на шести имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants_iy2iBaK.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants.png`,
      title: _t("Съемный протез на четырех имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.png`,
      title: _t("Условно съемный протез на шести имплантах")
    }],
    photo: [{
      photo: require("./Photos/Фото8_mhANL1s.jpg"),
      title: _t("Все на шести")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Фото8_mhANL2s.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 2.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Фото8_mhANL3s.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 3.jpg"),
      title: _t("Все на четырех")
    }],
    vr: [{
      folder: "Total_multiunit_low",
      xCount: 107,
      yCount: 0,
      title: _t("Тотальный протез на имплантах"),
      preview: require("./VRPacks/Total_multiunit_low/0_107.jpg")
    }]
  }, {
    type: "adentyImplantProsthesisFixation_adentyBothImplant",
    title: _t("Установка имплантов на обоих челюстях"),
    text: _t('Существуют 2 основных типа расстановки имплантов на беззубые челюсти: "Все на четырех" (All on four) и "Все на шести" (All on six). <br> "Все на шести" подразумевает позиционирование имплантов в области 2-ых,4-ых и 6-ых зубов в каждом сегменте. <br> "Все на четырех" подразумевает позиционирование имплантов в области 2-ых, 5-ых зубов в каждом сегменте. Использование 6 имплантов на челюсти для создания опоры для протеза более надежный подход к протезированию, но во многих случаях используется 4 импланта на челюсти из-за недостатка кости. Часто недостаток кости, в которой должен фиксироваться имплант, может быть достаточно большой из-за долгого отсутствия зубов на челюсти, из-за использования съемного протеза долгий промежуток времени или после сложных удалений зубов. <br> Концепция изготовления протезов на 6-и имплантах позволяет включать в протез 12 - 14 зубов, что восстанавливает жевательную функцию почти полностью. Несъемные и условно - съемные протезы на четырех имплантах могут быть изготовлены максимум на 10 зубов и способны восстановить функцию жевания не более, чем на 70%.'),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.3-implants-installation-full${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Все на шести")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Все на четырех")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Все на четырех")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Протез цементной фиксации на шести имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants_iy2iBaK.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants.png`,
      title: _t("Съемный протез на четырех имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.png`,
      title: _t("Условно съемный протез на шести имплантах")
    }],
    photo: [{
      photo: require("./Photos/Фото8_mhANL1s.jpg"),
      title: _t("Все на шести")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Фото8_mhANL2s.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 2.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Фото8_mhANL3s.jpg"),
      title: _t("Все на четырех")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 3.jpg"),
      title: _t("Все на четырех")
    }],
    vr: [{
      folder: "Total_multiunit_low",
      xCount: 107,
      yCount: 0,
      title: _t("Тотальный протез на имплантах"),
      preview: require("./VRPacks/Total_multiunit_low/0_107.jpg")
    }, {
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }, {
      folder: "Circon_abutment_total",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Circon_abutment_total/0_32.jpg")
    }]
  }, {
    type: "cementImplantProsthesisFixationTop",
    title: _t("Цементная фиксация протеза к импланту"),
    text: _t("Цементная фиксация протеза к импланту - производится при помощи абатмента (специальная головка, которая прикручивается винтом к импланту). Абатмент формирует наддесневую часть конструкции, на которую крепится протез при помощи стоматологического цемента. Абатменты, в свою очередь, бывают стандартными и индивидуальными. Индивидуальные металлические и циркониевые абатменты выгодно отличаются от стандартных тем, что они помогают формировать десну вокруг импланта и обеспечивают лучшую эстетику мягких тканей."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.6-cement-fixation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Верх тотал на цирконевых абатментах.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Верх тотал на цирконевых абатментах.jpg`,
      title: "Протез на цирконевых абатментах"
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Мост на титановых абатментах")
    }],
    photo: [{
      photo: require("./Photos/Абатмент стандартный фото 1.jpg"),
      title: _t("Абатмент стандартный")
    }],
    vr: [{
      folder: "Circon_abutment_total",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на индивидуальных абатментах"),
      preview: require("./VRPacks/Circon_abutment_total/0_32.jpg")
    }]
  }, {
    type: "multiunitImplantProsthesisFixationTop",
    title: _t("Фиксация на мульти-юнитах"),
    text: _t("Винтовая фиксация протеза к импланту с использованием мульти-юнит абатмента - одна из самых надежных и практичных систем. Мульти-юнит - это переходник при помощи которого можно использовать все преимущества системы винтовой фиксации, но при этом ее использование не ограничивается случаями с не параллельным расположением имплантов в кости. Используется для протезов большой протяженности, для мостов на всю челюсть. Не используются для одиночных коронок."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.4-multiunit-fixation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Протез на мульти-юнитах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.png`,
      title: _t("Протез на мульти-юнитах Owerpress")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Условно-съемные протезы на мульти-юнитах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Соединения-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Соединения-1.jpg`,
      title: _t("Нижний протез на мульти-юнитах")
    }],
    photo: [{
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Протез на мульти-юнитах")
    }],
    vr: [{
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }]
  }, {
    type: "telescopImplantProsthesisFixationTop",
    title: _t("Фиксация протеза на телескопических коронках"),
    text: _t("Телескопические (двойные) коронки применяются в комбинации с дентальными имплантами и выступают в качестве якорного крепления различных видов съемных протезов. Такой вид фиксации состоит из двух типов элементов (внутренних и наружных). Первая часть является коронкой, соединенной с основной частью протеза. Вторая часть - металлический абатмент или зафиксированный на абатменте колпачок, с параллельными стенками. Как складывающаяся подзорная труба, коронка садится одна на другую, плотно удерживаясь на ней. Благодаря такой конструкции жевательная нагрузка равномерно перераспределяется между всеми имплантами. <br> Протезы на телескопических коронках являются разновидностью бюгельных протезов. Применяется данная концепция в случаях, когда для восстановления полноценной функции жевания недостаточно кости и установка необходимого количества имплантов затруднена. Идеальным количеством имплантов для качественной фиксации протеза является 4, но в некоторых случаях возможно и меньшее количество имплантов, так как протез способен частично опираться на десну."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.5-beam-fixation-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Тотал На Телескопах И Балках-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал На Телескопах И Балках-1.jpg`,
      title: _t("Мост на телескопических коронках и балках")
    }],
    photo: [{
      photo: require("./Photos/Телескопы и балки на имплантах.5265.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5266.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5267.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5269.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5270.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5273.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5274.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5276.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5277.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5278.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5279.jpg"),
      title: _t("Телескопические коронки с балками")
    }],
    vr: [{
      folder: "teleskopOnImplants",
      xCount: 90,
      yCount: 0,
      title: _t("Тотальный протез на телескопических коронках и балках"),
      preview: require("./VRPacks/teleskopOnImplants/0_21.jpg")
    }]
  }, {
    type: "cementImplantProsthesisFixationBoth",
    title: _t("Цементная фиксация протеза к импланту"),
    text: _t("Цементная фиксация протеза к импланту - производится при помощи абатмента (специальная головка, которая прикручивается винтом к импланту). Абатмент формирует наддесневую часть конструкции, на которую крепится протез при помощи стоматологического цемента. Абатменты, в свою очередь, бывают стандартными и индивидуальными. Индивидуальные металлические и циркониевые абатменты выгодно отличаются от стандартных тем, что они помогают формировать десну вокруг импланта и обеспечивают лучшую эстетику мягких тканей."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.6-cement-fixation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Верх тотал на цирконевых абатментах.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Верх тотал на цирконевых абатментах.jpg`,
      title: "Протез на цирконевых абатментах"
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Мост на титановых абатментах")
    }],
    photo: [{
      photo: require("./Photos/Абатмент стандартный фото 1.jpg"),
      title: _t("Абатмент стандартный")
    }],
    vr: [{
      folder: "Circon_abutment_total",
      xCount: 105,
      yCount: 0,
      title: _t("Тотальный протез цементной фиксации"),
      preview: require("./VRPacks/Circon_abutment_total/0_65.jpg")
    }]
  }, {
    type: "multiunitImplantProsthesisFixationBoth",
    title: _t("Фиксация на мульти-юнитах"),
    text: _t("Винтовая фиксация протеза к импланту с использованием мульти-юнит абатмента - одна из самых надежных и практичных систем. Мульти-юнит - это переходник при помощи которого можно использовать все преимущества системы винтовой фиксации, но при этом ее использование не ограничивается случаями с не параллельным расположением имплантов в кости. Используется для протезов большой протяженности, для мостов на всю челюсть. Не используются для одиночных коронок."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.4-multiunit-fixation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Протез на мульти-юнитах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.png`,
      title: _t("Протез на мульти-юнитах Owerpress")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Условно-съемные протезы на мульти-юнитах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Соединения-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Соединения-1.jpg`,
      title: _t("Нижний протез на мульти-юнитах")
    }],
    photo: [{
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Протез на мульти-юнитах")
    }],
    vr: [{
      folder: "Total_multiunit_low",
      xCount: 107,
      yCount: 0,
      title: _t("Тотальный протез на имплантах"),
      preview: require("./VRPacks/Total_multiunit_low/0_107.jpg")
    }, {
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }]
  }, {
    type: "telescopImplantProsthesisFixationBoth",
    title: _t("Фиксация протеза на телескопических коронках"),
    text: _t("Телескопические (двойные) коронки применяются в комбинации с дентальными имплантами и выступают в качестве якорного крепления различных видов съемных протезов. Такой вид фиксации состоит из двух типов элементов (внутренних и наружных). Первая часть является коронкой, соединенной с основной частью протеза. Вторая часть - металлический абатмент или зафиксированный на абатменте колпачок, с параллельными стенками. Как складывающаяся подзорная труба, коронка садится одна на другую, плотно удерживаясь на ней. Благодаря такой конструкции жевательная нагрузка равномерно перераспределяется между всеми имплантами. <br> Протезы на телескопических коронках являются разновидностью бюгельных протезов. Применяется данная концепция в случаях, когда для восстановления полноценной функции жевания недостаточно кости и установка необходимого количества имплантов затруднена. Идеальным количеством имплантов для качественной фиксации протеза является 4, но в некоторых случаях возможно и меньшее количество имплантов, так как протез способен частично опираться на десну."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.5-beam-fixation-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Тотал На Телескопах И Балках-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал На Телескопах И Балках-1.jpg`,
      title: _t("Мост на телескопических коронках и балках")
    }],
    photo: [{
      photo: require("./Photos/Телескопы и балки на имплантах.5265.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5266.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5267.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5269.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5270.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5273.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5274.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5276.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5277.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5278.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5279.jpg"),
      title: _t("Телескопические коронки с балками")
    }],
    vr: [{
      folder: "teleskopOnImplants",
      xCount: 90,
      yCount: 0,
      title: _t("Тотальный протез на телескопических коронках и балках"),
      preview: require("./VRPacks/teleskopOnImplants/0_21.jpg")
    }]
  }, {
    type: "cementImplantProsthesisFixationBottom",
    title: _t("Цементная фиксация протеза к импланту"),
    text: _t("Цементная фиксация протеза к импланту - производится при помощи абатмента (специальная головка, которая прикручивается винтом к импланту). Абатмент формирует наддесневую часть конструкции, на которую крепится протез при помощи стоматологического цемента. Абатменты, в свою очередь, бывают стандартными и индивидуальными. Индивидуальные металлические и циркониевые абатменты выгодно отличаются от стандартных тем, что они помогают формировать десну вокруг импланта и обеспечивают лучшую эстетику мягких тканей."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.6-cement-fixation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Верх тотал на цирконевых абатментах.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Верх тотал на цирконевых абатментах.jpg`,
      title: _t("Протез на цирконевых абатментах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Мост на титановых абатментах")
    }],
    photo: [{
      photo: require("./Photos/Абатмент стандартный фото 1.jpg"),
      title: _t("Абатмент стандартный")
    }]
  }, {
    type: "multiunitImplantProsthesisFixationBottom",
    title: _t("Фиксация на мульти-юнитах"),
    text: _t("Винтовая фиксация протеза к импланту с использованием мульти-юнит абатмента - одна из самых надежных и практичных систем. Мульти-юнит - это переходник при помощи которого можно использовать все преимущества системы винтовой фиксации, но при этом ее использование не ограничивается случаями с не параллельным расположением имплантов в кости. Используется для протезов большой протяженности, для мостов на всю челюсть. Не используются для одиночных коронок."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.4-multiunit-fixation-full-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Протез на мульти-юнитах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах.png`,
      title: _t("Протез на мульти-юнитах Owerpress")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Условно-съемные протезы на мульти-юнитах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Соединения-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Соединения-1.jpg`,
      title: _t("Нижний протез на мульти-юнитах")
    }],
    photo: [{
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Протез на мульти-юнитах")
    }],
    vr: [{
      folder: "Total_multiunit_low",
      xCount: 107,
      yCount: 0,
      title: _t("Тотальный протез на имплантах"),
      preview: require("./VRPacks/Total_multiunit_low/0_107.jpg")
    }]
  }, {
    type: "telescopImplantProsthesisFixationBottom",
    title: _t("Фиксация протеза на телескопических коронках"),
    text: _t("Телескопические (двойные) коронки применяются в комбинации с дентальными имплантами и выступают в качестве якорного крепления различных видов съемных протезов. Такой вид фиксации состоит из двух типов элементов (внутренних и наружных). Первая часть является коронкой, соединенной с основной частью протеза. Вторая часть - металлический абатмент или зафиксированный на абатменте колпачок, с параллельными стенками. Как складывающаяся подзорная труба, коронка садится одна на другую, плотно удерживаясь на ней. Благодаря такой конструкции жевательная нагрузка равномерно перераспределяется между всеми имплантами. <br> Протезы на телескопических коронках являются разновидностью бюгельных протезов. Применяется данная концепция в случаях, когда для восстановления полноценной функции жевания недостаточно кости и установка необходимого количества имплантов затруднена. Идеальным количеством имплантов для качественной фиксации протеза является 4, но в некоторых случаях возможно и меньшее количество имплантов, так как протез способен частично опираться на десну."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.5-beam-fixation-partial-adentia${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Тотал На Телескопах И Балках-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал На Телескопах И Балках-1.jpg`,
      title: _t("Мост на телескопических коронках и балках")
    }],
    photo: [{
      photo: require("./Photos/Телескопы и балки на имплантах.5265.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5266.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5267.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5269.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5270.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5273.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5274.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5276.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5277.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5278.jpg"),
      title: _t("Телескопические коронки с балками")
    }, {
      photo: require("./Photos/Телескопы и балки на имплантах.5279.jpg"),
      title: _t("Телескопические коронки с балками")
    }],
    vr: [{
      folder: "teleskopOnImplants",
      xCount: 90,
      yCount: 0,
      title: _t("Тотальный протез на телескопических коронках и балках"),
      preview: require("./VRPacks/teleskopOnImplants/0_21.jpg")
    }]
  }, {
    type: "removableProsthesisAlternate",
    title: _t("Альтернатива съемному протезированию"),
    text: _t("<b>Обратите внимание, что полный съемный протез является лишь временным решением. </b> <br> Современная стоматология доказала, что данные протезы можно использовать только временно, потому что слизистая не способна нести на себе нагрузку жевания. Из-за постоянного давления десна перестает нужным образом питаться кровью и начинает истончаться, а вместе с ней происходит убыль кости в месте опоры. Это приводит к потере фиксации протеза, а что самое худшее, усложняет дальнейшее протезирование на имплантах. В большинстве случаев требуется наращивание кости перед имплантацией после долговременного использования съемных протезов. <br> <b>Постоянным решением в данном клиническом случае является Дентальная имплантация.</b> <br> Дентальная имплантация - вживление импланта в костные ткани, для создания искусственной опоры, на которую в последующем одевается зубной протез. Зубной имплант заменяет прежний корень зуба и используется, как для замещения одного зуба, так и протезирования всех зубов на челюсти. Импланты изготавливаются из специального титанового сплава. Специфичность изделия заключается в специальном покрытии, которое достигается обработкой песком и кислотами. Имплантация применяется в большинстве случаев с полной адентией. Данная методика признана самым надежный и высоко эстетический способ протезирования беззубых челюстей. Протезы на имплантах способны восстановить жевательную функцию до 100%."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.8-saved-removable-full${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/AtrofiaFull.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/AtrofiaFull.jpg`,
      title: _t("Атрофия десны")
    }, {
      video: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Протез на мультиюнитах 1.jpg`,
      title: _t("Тотальный протез на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Тотал Все На 4 Мультиюниты-1.jpg`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Винтовая_Фиксация-Временная-конструкция.png`,
      title: _t("Протез на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Абатмент титановый 3.png`,
      title: _t("Протезы на имплантах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants_iy2iBaK.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable_Prosthesis_On_Implants.png`,
      title: _t("Протезы на имплантах")
    }],
    photo: [{
      photo: require("./Photos/Протез на мультиюнитах 1.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Протез на мультиюнитах 3.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL1s.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL2s.jpg"),
      title: _t("Протез на имплантах")
    }, {
      photo: require("./Photos/Фото8_mhANL3s.jpg"),
      title: _t("Протез на имплантах")
    }],
    vr: [{
      folder: "Total_multiunit_low",
      xCount: 107,
      yCount: 0,
      title: _t("Тотальный протез на имплантах"),
      preview: require("./VRPacks/Total_multiunit_low/0_107.jpg")
    }, {
      folder: "Total_multiunit_up",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Total_multiunit_up/0_32.jpg")
    }, {
      folder: "Circon_abutment_total",
      xCount: 105,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/Circon_abutment_total/0_32.jpg")
    }]
  }, {
    type: "selectAbutmentTooth",
    title: _t("Коронки на опорных зубах протеза"),
    text: _t("<b>Опорные зубы мостовидного протеза</b> всегда накрываются коронками, которые будут выступать в роли несущих колонн. Мостовидная конструкция может иметь минимум два опорных зуба. Подобные протезы напоминают наше представление о мосте через реку. Данная конструкция опирается на оба берега и возможно на дополнительные колонны посредине. Только с одной опорой мост существовать не может. По такому же принципу изготавливается и зубной мост. В промежутке между коронками не должно быть более двух отсутствующих зубов, иначе опорные зубы не выдержат жевательной нагрузки. Исключением может быть только отсутствие нижних резцов. В данном случае в промежутке может быть 3 зуба. Зуб под опорную коронку обрабатывается со всех сторон до уровня десны. При обработке убирается около 1 мм зубных тканей. Зуб, который выступает в роли опорного должен быть здоровым или полностью пролеченным, иначе при воспалении можно потерять всю конструкцию. Для лечения зуба под коронкой необходим доступ, который можно получить только после снятия мостовидного протеза. При извлечении протеза из полости рта в большинстве случаев для дальнейшего использования он не пригоден."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.9-abutment-tooth-bridge${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Коронки зубы в промежутках.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Коронки зубы в промежутках.jpg`,
      title: _t("Коронки в мостовидных протезах")
    }, {
      video: `${CDN_DOMAIN}/Videos/Мост 13-16 Colleagial.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Мост 13-16 Colleagial.jpg`,
      title: _t("Опорные коронки в мосте")
    }],
    photo: [{
      photo: require("./Photos/Мост подкова 2.jpg"),
      title: _t("Коронки в мосте")
    }, {
      photo: require("./Photos/110039.jpg"),
      title: _t("Коронки в протезе")
    }, {
      photo: require("./Photos/110037.jpg"),
      title: _t("Коронки в протезе")
    }],
    vr: [{
      folder: "brige",
      xCount: 90,
      yCount: 0,
      title: _t("Мостовидный протез"),
      preview: require("./VRPacks/brige/0_6.jpg")
    }]
  }, {
    type: "selectSuspendedTooth",
    title: _t("Подвесные зубы"),
    text: _t("<b> Подвесной зуб </b>– это искусственный зуб, замещающий отсутствующий в мостовидном протезе на опорных зубах. Подвесной зуб имеет промывную зону, которая прилегает к десне. Различаются типы подвесных зубов по форме промывной зоны. Она может быть такой, что искусственный зуб только слегка касается десны, а может охватывать зуб значительной поверхностью. <br> С точки зрения удобства, зуб который плотно ложится на десну более удобный, но с другой стороны такая форма промыва не позволяет тщательно вычищать протез со стороны опоры на десну. Форма промыва выбирается исходя из состояния и формы десны, а также отталкиваясь от гигиенического состояния полости рта пациента. Принято считать, что один зуб может нести на себе нагрузку одного подвесного зуба. Соответственно между ними может находиться один или максимум 2 подвесных зуба. Если у Вас получилось больше, в таком случае вернитесь на пару шагов назад и выберите другой вид протезирования."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.8-hanging-teeth-bridge${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Мост подвесные зубы Colleagial.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Мост подвесные зубы Colleagial.jpg`,
      title: _t("Подвесные зубы в мосте")
    }, {
      video: `${CDN_DOMAIN}/Videos/Мост подкова Colleagial.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Мост подкова Colleagial.jpg`,
      title: _t("Подвесные зубы в тотальном мосте")
    }],
    photo: [{
      photo: require("./Photos/110038.jpg"),
      title: _t("Промежутки между зубами")
    }, {
      photo: require("./Photos/110044.jpg"),
      title: _t("Подвесные зубы")
    }, {
      photo: require("./Photos/110047.jpg"),
      title: _t("Зубы в мостовидном протезе")
    }, {
      photo: require("./Photos/Мост 2.jpg"),
      title: _t("Один зуб подвесной зуб")
    }, {
      photo: require("./Photos/Мост подкова 1.jpg"),
      title: _t("Подвесные зубы в тотальном протезе")
    }],
    vr: [{
      folder: "brige",
      xCount: 90,
      yCount: 0,
      title: _t("Мостовидный протез"),
      preview: require("./VRPacks/brige/0_6.jpg")
    }]
  }, {
    type: "selectToothConnections",
    title: _t("Соединения между коронками и искусственными зубами"),
    text: _t("<b> Соединения между подвесными зубами и коронками (коннекторы) </b> - конструкционные решения, необходимые для создания целостности протезной конструкции. Благодаря коннекторам жевательная нагрузка распределяется по всей протяженности моста и переносится на опорные зубы. Коннекторы необходимо ставить во всех местах, где подвесные зубы соединяются друг с другом или с коронками. Коронки также соединяются коннекторами при возможности. Чем более цельной будет конструкция на опорных зубах, тем более долговечной и стабильной она будет."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.10-connections-bridge${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Мост соединения Colleagial.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Мост соединения Colleagial.jpg`,
      title: _t("Соединения подвесных зубов и коронок")
    }, {
      video: `${CDN_DOMAIN}/Videos/Соединения подкова.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Соединения подкова.jpg`,
      title: _t("Коннекторы в тотальном мосте")
    }],
    photo: [{
      photo: require("./Photos/110048.jpg"),
      title: _t("Соединения подвесных зубов и коронок")
    }, {
      photo: require("./Photos/110049.jpg"),
      title: _t("Коннекторы")
    }, {
      photo: require("./Photos/Мост 3.jpg"),
      title: _t("Коннекторы")
    }],
    vr: [{
      folder: "brige",
      xCount: 90,
      yCount: 0,
      title: _t("Мостовидный протез"),
      preview: require("./VRPacks/brige/0_6.jpg")
    }]
  }, {
    type: "bugelBase",
    title: _t("Металлический базис"),
    text: _t("Металлический базис считается более долговечным и удобным для использования. Основным преимуществом данных протезов считается возможность распределять жевательную нагрузку между оставшимися зубами и десной. Это замедляет процесс уменьшения объема слизистой и кости под протезом. Это качество может сохраняться только при небольшом количестве отсутствующих подряд зубов. При большой протяженности дефекта с отсутствием зубов подобные протезы использовать нежелательно. Каркас бюгельного протеза не обеспечивает такого прилегания к десне, которое способно удерживать и стабилизировать его, как в случае с пластиковыми пластинчатыми протезами."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.19-metall-basis${langPrefix}.mp4`
    },
    video: [// {
    // video: `${CDN_DOMAIN}/Videos/`,
    // videoPoster: "",
    // title: _t("Соединения подвесных зубов и коронок"),
    // },
    {
      video: `${CDN_DOMAIN}/Videos/Бюгель 14, 24, 15, 25.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Бюгель 14, 24, 15, 25.jpg`,
      title: _t("Бюгельный протез")
    }, {
      video: `${CDN_DOMAIN}/Videos/бюгель верх Colleagial.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/бюгель верх Colleagial.jpg`,
      title: _t("Дуговой металлический базис")
    }, {
      video: `${CDN_DOMAIN}/Videos/Removable Prosthesis Fixation On The Beam.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Removable-Prosthesis-Fixation-On-The-Beam.png`,
      title: _t("Металлический каркас")
    }, {
      video: `${CDN_DOMAIN}/Videos/Prosthesis On Telescopic Crowns.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Prosthesis-On-Telescopic-Crowns.png`,
      title: _t("Металлический каркас")
    }],
    photo: [{
      photo: require("./Photos/Бюгель 1.jpg"),
      title: _t("Бюгельный протез")
    }, {
      photo: require("./Photos/Бюгель 2.jpg"),
      title: _t("Бюгельный протез")
    }, {
      photo: require("./Photos/Бюгель 3.jpg"),
      title: _t("Бюгельный протез")
    }, {
      photo: require("./Photos/Бюгель 5.jpg"),
      title: _t("Бюгельный протез")
    }, {
      photo: require("./Photos/Съемный 2.jpg"),
      title: _t("Бюгельный протез")
    }, {
      photo: require("./Photos/Съемный 3.jpg"),
      title: _t("Бюгельный протез")
    }, {
      photo: require("./Photos/Съемный 4.jpg"),
      title: _t("Бюгельный протез")
    }],
    vr: [{
      folder: "Bugel_metal",
      xCount: 90,
      yCount: 0,
      title: _t("Бюгельный протез"),
      preview: require("./VRPacks/Bugel_metal/0_1.jpg")
    }, {
      folder: "Tbug_attach",
      xCount: 86,
      yCount: 0,
      title: _t("Протез на мульти-юнитах"),
      preview: require("./VRPacks/bug_attach/0_1.jpg")
    }]
  }, {
    type: "plasticBase",
    title: _t("Пластиковый базис"),
    text: _t('Пластиковый базис протеза более эстетичен и может изготавливаться из акрила или нейлона. Протезы подобной конструкции называются "пластинчатые" из-за формы базиса. Весь протез полностью имитирует десну, а пластиковые зубы идеально похожи на естественные зубы человека. Крепятся в полости рта частичные съемные протезы за оставшиеся зубы при помощи специальных удерживающих компонентов "кламмеров", которые ввариваются в базис. Они могут быть металлические или пластиковые, под цвет зуба или под цвет десны.'),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.17-plastic-basis${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Nylon Prosthesis.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Nylon-Prosthesis.png`,
      title: _t("Нейлоновый съемный протез")
    }, {
      video: `${CDN_DOMAIN}/Videos/Dental Microprosthesis Removable.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Dental Microprosthesis Removable.png`,
      title: _t("Микропротез съемный")
    }, {
      video: `${CDN_DOMAIN}/Videos/Akril_2_0.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Akril_1_0.jpg`,
      title: _t("Микропротез съемный")
    }, {
      video: `${CDN_DOMAIN}/Videos/Akril_2_0.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Akril_1_0.jpg`,
      title: _t("Микропротез съемный")
    }],
    photo: [{
      photo: require("./Photos/Съемный 5.jpg"),
      title: _t("Нейлоновый протез")
    }, {
      photo: require("./Photos/Съемный 12.jpg"),
      title: _t("Акриловый протез")
    }, {
      photo: require("./Photos/Съемный 9.jpg"),
      title: _t("Микропротез")
    }, {
      photo: require("./Photos/Съемный 8.jpg"),
      title: _t("Типы пластиковых базисов")
    }, {
      photo: require("./Photos/Съемный 14.jpg"),
      title: _t("Протез")
    }, {
      photo: require("./Photos/Съемный 13.jpg"),
      title: _t("Протез с кламмерами")
    }],
    vr: [{
      folder: "Neilon_prot",
      xCount: 105,
      yCount: 0,
      title: _t("Нейлоновый протез"),
      preview: require("./VRPacks/Neilon_prot/0_1.jpg")
    }, {
      folder: "Tbug_attach",
      xCount: 86,
      yCount: 0,
      title: _t("Замена на акриловый"),
      preview: require("./VRPacks/bug_attach/0_1.jpg")
    }]
  }, {
    type: "removableProstheticsTooth",
    title: _t("Зуб съемного протеза"),
    text: _t("<b>Зуб в съемном протезе</b> - это компонент конструкции, который обеспечивает перетирание пищи в процессе жевания. Они изготавливаются из высокопрочного многослойного акрилового полимера, что делает их эстетичными и износостойкими. Пластиковые зубы идеально похожи на естественные зубы человека и потому, помимо жевательной функции, выполняют также эстетическую функцию. Подбор цвета искусственных зубов происходит под естественные зубы пациента. Широкий цветовой спектр гарнитуров зубов и применение специальных расцветок позволяет специалисту осуществить точное попадание в цвет при изготовлении протеза. Фиксация зубов в базисе происходит при помощи химического соединения акрила с акрилом или физического соединения, с использованием специальных каналов внутри искусственных зубов."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.18-teeth-removeble-denture${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Съемные.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Съемные.jpg`,
      title: _t("Нейлоновый съемный протез")
    }],
    photo: [{
      photo: require("./Photos/Съемный 5.jpg"),
      title: _t("Нейлоновый протез")
    }, {
      photo: require("./Photos/Съемный 12.jpg"),
      title: _t("Акриловый протез")
    }, {
      photo: require("./Photos/Съемный 9.jpg"),
      title: _t("Микропротез")
    }, {
      photo: require("./Photos/Съемный 8.jpg"),
      title: _t("Типы пластиковых базисов")
    }, {
      photo: require("./Photos/Съемный 14.jpg"),
      title: _t("Протез")
    }, {
      photo: require("./Photos/Съемный 13.jpg"),
      title: _t("Протез с кламмерами")
    }]
  }, {
    type: "fixedProsthesisAlternate",
    title: _t("Альтернатива мостовидному протезированию"),
    text: _t("<b> Обратите внимание, что мостовидный протез требует обработки здоровых зубов под коронки для создания опоры.</b> Данный подход не считается самым приемлемым в современной стоматологии при наличии достойной альтернативы. <br> <b> Дентальная имплантация </b>считается самым современным решением в протезировании, которое позволяет возмещать любой дефект без обработки здоровых зубов под коронки. Также можно воспользоваться временной альтернативой, которой является протезирование съемными дентальными протезами и микропротезами. Данный подход не требует специальной подготовки опорных зубов и может использоваться в период подготовки к постоянному протезированию."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.12-saved-bridge${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/alternativeBridges.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/alternativeBridges.png`,
      title: _t("Альтернатива мостовидным протезам")
    }, {
      video: `${CDN_DOMAIN}/Videos/Crown On Implant With Individual Titanium Abutment.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Crown On Implant With Individual Titanium Abutment.png`,
      title: _t("Имплантация на нижней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/Имплантация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Имплантация.png`,
      title: _t("Имплантация на верхней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/Implantaciya S Pomoshyu Hirurgicheskogo Shablona.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Implantaciya-S-Pomoshyu-Hirurgicheskogo-Shablona.png`,
      title: _t("Хирургический шаблон на верхнюю челюсть")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Пилотный Протокол-26.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Пилотный-Протокол-26.png`,
      title: _t("Хирургический шаблон, пилотный протокол")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Полный Протокол-27.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Полный-Протокол-27.png`,
      title: _t("Хирургический шаблон, полный протокол")
    }],
    photo: [{
      photo: require("./Photos/Фото1_yXMoWOU.jpg"),
      title: _t("Имплантация 21 зуб")
    }, {
      photo: require("./Photos/Фото2_v0Hu4WI.jpg"),
      title: _t("Имплантация 45 зуб")
    }, {
      photo: require("./Photos/Фото4_bzw7oGH.jpg"),
      title: _t("Имплантация 46 зуб")
    }, {
      photo: require("./Photos/Фото4_1cuZIzf.jpg"),
      title: _t("Имплантация 45-46 зуб")
    }, {
      photo: require("./Photos/Фото7_vxsKpiR.jpg"),
      title: _t("Имплантация 25 зуб")
    }, {
      photo: require("./Photos/шаблон.jpg"),
      title: _t("Имплантация через хирургический шаблон")
    }, {
      photo: require("./Photos/шаблон3.jpg"),
      title: _t("Хирургический шаблон")
    }, {
      photo: require("./Photos/Фото_v4FA9Mb.jpg"),
      title: _t("Хирургический шаблон на 6 имплантов")
    }, {
      photo: require("./Photos/Фото9_DqA0bXI.jpg"),
      title: _t("Хирургический шаблон 14 зуб")
    }, {
      photo: require("./Photos/Фото10_CZEVBLq.jpg"),
      title: _t("Протез с имплантом на модели")
    }],
    vr: [{
      folder: "Circon_abutment",
      xCount: 105,
      yCount: 0,
      title: _t("Имплант в области центрального зуба"),
      preview: require("./VRPacks/Circon_abutment/0_1.jpg")
    }, {
      folder: "Titan_abutment_46",
      xCount: 89,
      yCount: 0,
      title: _t("Имплант в области жевательного зуба"),
      preview: require("./VRPacks/Titan_abutment_46/0_1.jpg")
    }, {
      folder: "multiunit_44-46",
      xCount: 91,
      yCount: 0,
      title: _t("Импланты в боковом участке"),
      preview: require("./VRPacks/multiunit_44-46/0_1.jpg")
    }]
  }, {
    type: "removableProstheticsAlternate",
    title: _t("Альтернатива съемному протезированию"),
    text: _t("<b> Обратите внимание, что съемный протез является лишь временным решением. </b> Современная стоматология доказала, что данные протезы можно использовать только временно, потому что слизистая не способна нести на себе нагрузку жевания. Из-за постоянного давления десна перестает нужным образом питаться кровью и начинает истончаться, а вместе с ней происходит убыль кости в месте опоры. Это приводит к потере фиксации протеза, а что самое худшее, усложняет дальнейшее протезирование на имплантах. В большинстве случаев требуется наращивание кости перед имплантацией после долговременного использования съемных протезов. <br> <b>Постоянным решением в данном клиническом случае является дентальная имплантация или несъемное протезирование мостовидными протезами. </b>"),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.15-saved-removable-partial${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Атрофия десны Colleagial.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Атрофия десны Colleagial.jpg`,
      title: _t("Атрофия десны")
    }, {
      video: `${CDN_DOMAIN}/Videos/ТотИмплантация Col.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ТотИмплантация-Col.png`,
      title: _t("Дентальная имплантация")
    }, {
      video: `${CDN_DOMAIN}/Videos/Crown On Implant With Individual Titanium Abutment.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Crown On Implant With Individual Titanium Abutment.png`,
      title: _t("Имплантация на нижней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/Имплантация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Имплантация.png`,
      title: _t("Имплантация на верхней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/Implantaciya S Pomoshyu Hirurgicheskogo Shablona.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Implantaciya-S-Pomoshyu-Hirurgicheskogo-Shablona.png`,
      title: _t("Хирургический шаблон на верхнюю челюсть")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Пилотный Протокол-26.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Пилотный-Протокол-26.png`,
      title: _t("Хирургический шаблон, пилотный протокол")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Полный Протокол-27.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Полный-Протокол-27.png`,
      title: _t("Хирургический шаблон, полный протокол")
    }],
    photo: [{
      photo: require("./Photos/Фото1_yXMoWOU.jpg"),
      title: _t("Имплантация 21 зуб")
    }, {
      photo: require("./Photos/Фото2_v0Hu4WI.jpg"),
      title: _t("Имплантация 45 зуб")
    }, {
      photo: require("./Photos/Фото4_bzw7oGH.jpg"),
      title: _t("Имплантация 46 зуб")
    }, {
      photo: require("./Photos/Фото4_1cuZIzf.jpg"),
      title: _t("Имплантация 45-46 зуб")
    }, {
      photo: require("./Photos/Фото7_vxsKpiR.jpg"),
      title: _t("Имплантация 25 зуб")
    }, {
      photo: require("./Photos/шаблон.jpg"),
      title: _t("Имплантация через хирургический шаблон")
    }, {
      photo: require("./Photos/шаблон3.jpg"),
      title: _t("Хирургический шаблон")
    }, {
      photo: require("./Photos/Фото_v4FA9Mb.jpg"),
      title: _t("Хирургический шаблон на 6 имплантов")
    }, {
      photo: require("./Photos/Фото9_DqA0bXI.jpg"),
      title: _t("Хирургический шаблон 14 зуб")
    }, {
      photo: require("./Photos/Фото10_CZEVBLq.jpg"),
      title: _t("Протез с имплантом на модели")
    }],
    vr: [{
      folder: "Circon_abutment",
      xCount: 105,
      yCount: 0,
      title: _t("Имплант в области центрального зуба"),
      preview: require("./VRPacks/Circon_abutment/0_1.jpg")
    }, {
      folder: "Titan_abutment_46",
      xCount: 89,
      yCount: 0,
      title: _t("Имплант в области жевательного зуба"),
      preview: require("./VRPacks/Titan_abutment_46/0_1.jpg")
    }, {
      folder: "multiunit_44-46",
      xCount: 91,
      yCount: 0,
      title: _t("Импланты в боковом участке"),
      preview: require("./VRPacks/multiunit_44-46/0_1.jpg")
    }]
  }, {
    type: "optionalImplantationPartialAdentia",
    title: _t("Дополнительно при имплантации"),
    text: _t("<b> Для качественной установки имплантов могут понадобиться дополнительные процедуры и вспомогательные устройства. </b> <br> <b> Хирургические шаблоны </b> используются в большинстве случаев установки имплантов. Это специальная капа, выполненная методом 3D печати, при помощи которой доктор имеет возможность установить импланты в заранее спрогнозированное место. Данный подход является современным и высокотехнологичным. Использование хирургических шаблонов ускоряет процесс установки имплантов и минимизирует риски, связанные с операцией и дальнейшим использованием протеза. <br> При установке имплантов на верхнюю челюсть, если толщина кости менее 8 мм в области установки, необходимо применять процедуру синус-лифтинг. <br> <b> Синус-лифтинг </b> - это восстановление объема костной ткани, необходимого для успешной и безопасной имплантации. Цель операции - увеличить толщину кости между нижним краем челюсти и дном гайморовой пазухи. <br> Также при недостаточном количестве кости, на верхней и на нижней челюсти используется процедура <b> внешнего наращивания кости </b>. Она необходима при сильной атрофии тканей и после потери объема кости вследствие сложных удалений зубов.<br> <b>Гингивальная пластика (мягкотканная пластика) </b> применяется при имплантации в случаях, когда произошло изменение формы десен в области протезирования или слизистая истончилась вследствие атрофии. Очень важно применять данный подход для улучшения эстетики и для того, чтобы исключить застревание пищи между зубами. Существует несколько методик по увеличению объема десны и ее формы. В настоящее время пластика применяется очень часто в случаях, когда основным запросом при обращении к стоматологу является улучшение эстетики. При соблюдении должной гигиены эффект может быть достаточно длительным. <br> <b>Ортодонтическое лечение </b> - применяется перед имплантацией и протезированием в случаях, когда из-за долгого отсутствия зубов произошло смещение оставшихся зубов в сторону дефекта. При подобном неконтролируемом изменении положения зубов очень часто уменьшается место в области отсутствующих зубов, необходимое для осуществления имплантации. Нормализация положения зубов происходит при помощи брекет систем или других ортодонтических методик."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.1.11-saved-impl${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Implantaciya S Pomoshyu Hirurgicheskogo Shablona.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Implantaciya-S-Pomoshyu-Hirurgicheskogo-Shablona.png`,
      title: _t("Хирургический шаблон на верхнюю челюсть")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Пилотный Протокол-26.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Пилотный-Протокол-26.png`,
      title: _t("Хирургический шаблон, пилотный протокол")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Полный Протокол-27.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Полный-Протокол-27.png`,
      title: _t("Хирургический шаблон, полный протокол")
    }, {
      video: `${CDN_DOMAIN}/Videos/Синус_лифтинг_имплантация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Синус_лифтинг_имплантация.jpg`,
      title: _t("Имплантация после синус-лифтинга")
    }, {
      video: `${CDN_DOMAIN}/Videos/Закрытый_синус_лифтинг.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Закрытый_синус_лифтинг.jpg`,
      title: _t("Закрытый синус-лифтинг")
    }, {
      video: `${CDN_DOMAIN}/Videos/Открытый_синус_лифтинг.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Открытый_синус_лифтинг.jpg`,
      title: _t("Открытый синус-лифтинг")
    }, {
      video: `${CDN_DOMAIN}/Videos/Восстановление_Костной_Ткани.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Восстановление_Костной_Ткани.jpg`,
      title: _t("Восстановление костной ткани после удаления")
    }, {
      video: `${CDN_DOMAIN}/Videos/Peremeshenie_Kostnogo_Bloka.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Peremeshenie_Kostnogo_Bloka.jpg`,
      title: _t("Восстановление костной ткани")
    }, {
      video: `${CDN_DOMAIN}/Videos/36 импл орто видео.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/36 импл орто видео.jpg`,
      title: _t("Создание места под имплант")
    }, {
      video: `${CDN_DOMAIN}/Videos/Гингива Импланты.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Гингива Импланты.jpg`,
      title: _t("Десневая пластика после имплантации")
    }],
    photo: [{
      photo: require("./Photos/шаблон 1.jpg"),
      title: _t("Установка импланта с хирургическим шаблоном")
    }, {
      photo: require("./Photos/Фото_v4FA9Mb.jpg"),
      title: _t("Хирургический шаблон для пилотного сверления")
    }, {
      photo: require("./Photos/шаблон 3.jpg"),
      title: _t("Хирургический шаблон")
    }, {
      photo: require("./Photos/синус 1.jpg"),
      title: _t("Синус-лифтинг этап 1")
    }, {
      photo: require("./Photos/синус 2.jpg"),
      title: _t("Синус-лифтинг этап 2")
    }, {
      photo: require("./Photos/синус 3.jpg"),
      title: _t("Синус-лифтинг этап 3")
    }, {
      photo: require("./Photos/синус 5.jpg"),
      title: _t("Синус-лифтинг этап 5")
    }, {
      photo: require("./Photos/синус 6.jpg"),
      title: _t("Синус-лифтинг этап 6")
    }, {
      photo: require("./Photos/синус 7.jpg"),
      title: _t("Синус-лифтинг этап 7")
    }, {
      photo: require("./Photos/bone photo 0.jpg"),
      title: _t("Восстановление кости в лунке удаленного зуба")
    }, {
      photo: require("./Photos/bone photo1.jpg"),
      title: _t("Восстановление кости в лунке удаленного зуба")
    }, {
      photo: require("./Photos/bone photo2.jpg"),
      title: _t("Восстановление кости в лунке удаленного зуба")
    }, {
      photo: require("./Photos/Гингива импланты.jpg"),
      title: _t("Десневая пластика после имплантации")
    }, {
      photo: require("./Photos/Гингива импланты.5515.jpg"),
      title: _t("Десневая пластика после имплантации")
    }]
  }, {
    type: "optionalImplantationFullAdentia",
    title: _t("Дополнительно при имплантации"),
    text: _t("<b> Для качественной установки имплантов могут понадобиться дополнительные процедуры и вспомогательные устройства. </b> <br> <b> Хирургические шаблоны </b> используются в большинстве случаев установки имплантов. Это специальная капа, выполненная методом 3D печати, при помощи которой доктор имеет возможность установить импланты в заранее спрогнозированное место. Данный подход является современным и высокотехнологичным. Использование хирургических шаблонов ускоряет процесс установки имплантов и минимизирует риски, связанные с операцией и дальнейшим использованием протеза. <br> При установке имплантов на верхнюю челюсть, если толщина кости менее 8 мм в области установки, необходимо применять процедуру синус-лифтинг. <br> <b> Синус-лифтинг </b> - это восстановление объема костной ткани, необходимого для успешной и безопасной имплантации. Цель операции - увеличить толщину кости между нижним краем челюсти и дном гайморовой пазухи. <br> Также при недостаточном количестве кости, на верхней и на нижней челюсти используется процедура <b> внешнего наращивания кости </b>. Она необходима при сильной атрофии тканей и после потери объема кости вследствие сложных удалений зубов.<br> <b>Гингивальная пластика (мягкотканная пластика) </b> применяется при имплантации в случаях, когда произошло изменение формы десен в области протезирования или слизистая истончилась вследствие атрофии. Очень важно применять данный подход для улучшения эстетики и для того, чтобы исключить застревание пищи между зубами. Существует несколько методик по увеличению объема десны и ее формы. В настоящее время пластика применяется очень часто в случаях, когда основным запросом при обращении к стоматологу является улучшение эстетики. При соблюдении должной гигиены эффект может быть достаточно длительным. <br> <b>Ортодонтическое лечение </b> - применяется перед имплантацией и протезированием в случаях, когда из-за долгого отсутствия зубов произошло смещение оставшихся зубов в сторону дефекта. При подобном неконтролируемом изменении положения зубов очень часто уменьшается место в области отсутствующих зубов, необходимое для осуществления имплантации. Нормализация положения зубов происходит при помощи брекет систем или других ортодонтических методик."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/1.2.7-saved-impl-full${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Implantaciya S Pomoshyu Hirurgicheskogo Shablona.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Implantaciya-S-Pomoshyu-Hirurgicheskogo-Shablona.png`,
      title: _t("Хирургический шаблон на верхнюю челюсть")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Пилотный Протокол-26.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Пилотный-Протокол-26.png`,
      title: _t("Хирургический шаблон, пилотный протокол")
    }, {
      video: `${CDN_DOMAIN}/Videos/Шаблон Полный Протокол-27.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Шаблон-Полный-Протокол-27.png`,
      title: _t("Хирургический шаблон, полный протокол")
    }, {
      video: `${CDN_DOMAIN}/Videos/Синус_лифтинг_имплантация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Синус_лифтинг_имплантация.jpg`,
      title: _t("Имплантация после синус-лифтинга")
    }, {
      video: `${CDN_DOMAIN}/Videos/Закрытый_синус_лифтинг.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Закрытый_синус_лифтинг.jpg`,
      title: _t("Закрытый синус-лифтинг")
    }, {
      video: `${CDN_DOMAIN}/Videos/Открытый_синус_лифтинг.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Открытый_синус_лифтинг.jpg`,
      title: _t("Открытый синус-лифтинг")
    }, {
      video: `${CDN_DOMAIN}/Videos/Восстановление_Костной_Ткани.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Восстановление_Костной_Ткани.jpg`,
      title: _t("Восстановление костной ткани после удаления")
    }, {
      video: `${CDN_DOMAIN}/Videos/Peremeshenie_Kostnogo_Bloka.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Peremeshenie_Kostnogo_Bloka.jpg`,
      title: _t("Восстановление костной ткани")
    }, {
      video: `${CDN_DOMAIN}/Videos/36 импл орто видео.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/36 импл орто видео.jpg`,
      title: _t("Создание места под имплант")
    }, {
      video: `${CDN_DOMAIN}/Videos/Гингива Импланты.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Гингива Импланты.jpg`,
      title: _t("Десневая пластика после имплантации")
    }],
    photo: [{
      photo: require("./Photos/шаблон 1.jpg"),
      title: _t("Установка импланта с хирургическим шаблоном")
    }, {
      photo: require("./Photos/Фото_v4FA9Mb.jpg"),
      title: _t("Хирургический шаблон для пилотного сверления")
    }, {
      photo: require("./Photos/шаблон 3.jpg"),
      title: _t("Хирургический шаблон")
    }, {
      photo: require("./Photos/синус 1.jpg"),
      title: _t("Синус-лифтинг этап 1")
    }, {
      photo: require("./Photos/синус 2.jpg"),
      title: _t("Синус-лифтинг этап 2")
    }, {
      photo: require("./Photos/синус 3.jpg"),
      title: _t("Синус-лифтинг этап 3")
    }, {
      photo: require("./Photos/синус 5.jpg"),
      title: _t("Синус-лифтинг этап 5")
    }, {
      photo: require("./Photos/синус 6.jpg"),
      title: _t("Синус-лифтинг этап 6")
    }, {
      photo: require("./Photos/синус 7.jpg"),
      title: _t("Синус-лифтинг этап 7")
    }, {
      photo: require("./Photos/bone photo 0.jpg"),
      title: _t("Восстановление кости в лунке удаленного зуба")
    }, {
      photo: require("./Photos/bone photo1.jpg"),
      title: _t("Восстановление кости в лунке удаленного зуба")
    }, {
      photo: require("./Photos/bone photo2.jpg"),
      title: _t("Восстановление кости в лунке удаленного зуба")
    }, {
      photo: require("./Photos/Гингива импланты.jpg"),
      title: _t("Десневая пластика после имплантации")
    }, {
      photo: require("./Photos/Гингива импланты.5515.jpg"),
      title: _t("Десневая пластика после имплантации")
    }]
  }, {
    type: "esCustomSelect",
    title: _t("Произвольный выбор реставраций"),
    text: _t("Данный путь позволяет самостоятельно составить план эстетической реабилитации и изучить варианты типов реставраций. Система предлагает пошаговую форму, на каждом из этапов которой можно выбрать разные типы реставрации на отдельных зубах. На первом этапе предлагается выбрать зубы, которые будут облицовываться винирами. На втором этапе система позволяет обозначить зубы, которые будут накрываться коронками. На третьем этапе пользователю представится возможность обозначить зубы, которые будут реставрироваться при помощи композитных материалов. После создания предварительного плана реставрации, формулу зубов можно сохранить для дальнейшей коррекции и создания конечного плана реабилитации. "),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/2.0.2-random-selection${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/винир_1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/винир_превью_1.jpg`,
      title: _t("Винир")
    }, {
      video: `${CDN_DOMAIN}/Videos/коронки_1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/коронки_превью_1.jpg`,
      title: _t("Коронки")
    }, {
      video: `${CDN_DOMAIN}/Videos/реставрации_1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрации_превью_1.jpg`,
      title: _t("Реставрации фронтальных зубов")
    }],
    photo: [{
      photo: require("./Photos/виниры_0.jpg"),
      title: _t("Виниры")
    }, {
      photo: require("./Photos/виниры_3.jpg"),
      title: _t("Винир")
    }, {
      photo: require("./Photos/виниры_2.jpg"),
      title: _t("Виниры")
    }, {
      photo: require("./Photos/коронки_1.jpg"),
      title: _t("Коронки")
    }, {
      photo: require("./Photos/коронки_3.jpg"),
      title: _t("Зубные коронки")
    }, {
      photo: require("./Photos/коронки_5.jpg"),
      title: _t("Обработка зубов под коронки")
    }, {
      photo: require("./Photos/реставрации_0.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_1.jpg"),
      title: _t("Композитные реставрации")
    }, {
      photo: require("./Photos/реставрации_7.jpg"),
      title: _t("Реставрация передних зубов")
    }],
    vr: [{
      folder: "Veneers_2",
      xCount: 91,
      yCount: 0,
      title: _t("Реставрации винирами"),
      preview: require("./VRPacks/Veneers_2/0_54.jpg")
    }, {
      folder: "Crowns",
      xCount: 101,
      yCount: 0,
      title: _t("Реставрации коронками"),
      preview: require("./VRPacks/Crowns/0_67.jpg")
    }, {
      folder: "restavrations",
      xCount: 30,
      yCount: 0,
      title: _t("Композитные реставрации"),
      preview: require("./VRPacks/restavrations/0_15.jpg")
    }]
  }, {
    type: "esTypicalSelect",
    title: _t("Типовые решения для выбора реставраций"),
    text: _t("Эта опция предлагает готовые варианты решений, которые могут быть актуальны для разных типов улыбки. Система предлагает пошаговую форму, которая поможет определиться с необходимым количеством реставраций и их типом. После выбора типа улыбки, пользователю предлагается выбрать вид реставраций, а также предоставляется дополнительная информация для принятия решения. В описаниях можно изучить достоинства и недостатки, присущие материалам и методикам, при помощи которых осуществляются реставрации."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/2.0.1-smile-type-selection${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/реставрации_2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрации_превью_2.jpg`,
      title: _t("Реставрации 6 передних зубов верхней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/8 виниров верх.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/8 виниров верх.jpg`,
      title: _t("8 виниров на передние зубы верхней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/10 виниров верх.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/10 виниров верх.jpg`,
      title: _t("10 виниров на передние зубы верхней челюсти")
    }, {
      video: `${CDN_DOMAIN}/Videos/10 виниров верх низ.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/10 виниров верх низ.jpg`,
      title: _t("10 виниров на передние зубы верхней и нижней челюсти")
    }],
    photo: [{
      photo: require("./Photos/реставрации_0.jpg"),
      title: _t("Реставрации 6 передних зубов верхней челюсти")
    }, {
      photo: require("./Photos/виниры 8 верх.108.jpg"),
      title: _t("Виниры на 8 передних зубов верхней челюсти")
    }, {
      photo: require("./Photos/виниры 8 верх.109.jpg"),
      title: _t("Виниры на 8 передних зубов")
    }, {
      photo: require("./Photos/виниры 10 верх.79.jpg"),
      title: _t("Виниры на 10 передних зубов верхней челюсти")
    }, {
      photo: require("./Photos/виниры 10 верх.78.jpg"),
      title: _t("Виниры на 10 передних зубов")
    }, {
      photo: require("./Photos/виниры 10 верх.80.jpg"),
      title: _t("Виниры на 10 передних зубов")
    }, {
      photo: require("./Photos/Виниры 10 верх-низ.104.jpg"),
      title: _t("Виниры на 20 передних зубов")
    }, {
      photo: require("./Photos/Виниры 10 верх-низ.105.jpg"),
      title: _t("Виниры на 10 передних зубов верхней и нижней челюсти")
    }],
    vr: [{
      folder: "Veneers_2",
      xCount: 91,
      yCount: 0,
      title: _t("Реставрации винирами"),
      preview: require("./VRPacks/Veneers_2/0_54.jpg")
    }, {
      folder: "Crowns",
      xCount: 101,
      yCount: 0,
      title: _t("Реставрации коронками"),
      preview: require("./VRPacks/Crowns/0_67.jpg")
    }, {
      folder: "restavrations",
      xCount: 30,
      yCount: 0,
      title: _t("Композитные реставрации"),
      preview: require("./VRPacks/restavrations/0_15.jpg")
    }]
  }, {
    type: "esVeneersSelection",
    title: _t("Виниры"),
    text: _t("<b>Виниры</b> – тонкие пластинки из керамики, которые фиксируются на передней части зуба и по цвету не отличаются от эмали. Они скрывают дефекты зубов (желтизну, сколы, кривизну) в зоне улыбки и предназначены для улучшения эстетики зубного ряда. Виниры приклеиваются к зубам при помощи специальных адгезивных материалов, что позволяет им соединяться с эмалью естественных зубов на молекулярном уровне. Реставрация винирами, по сути, является заменой старой эмали зубов на новую, более прочную и эстетичную. Одним из преимуществ данного типа реставрации является то, что естественные зубы при использовании данной методики обрабатываются минимально. Виниры нельзя использовать в случаях, когда утрачена большая часть зуба, на зубе имеются старые реставрации большого объема, естественный зуб сильно окрашен изнутри (со стороны нерва). В таких случаях лучше применять зубные коронки для реставрации."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/2.0.3-veneers${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/винир_1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/винир_превью_1.jpg`,
      title: _t("Винир")
    }, {
      video: `${CDN_DOMAIN}/Videos/винир_2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/винир_превью_2.jpg`,
      title: _t("Виниры на передние зубы")
    }, {
      video: `${CDN_DOMAIN}/Videos/винир_3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/винир_превью_3.jpg`,
      title: _t("Обработка зубов под виниры")
    }, {
      video: `${CDN_DOMAIN}/Videos/Ceramic_Tabs.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Ceramic_Tabs.jpg`,
      title: _t("Керамические вкладки")
    }],
    photo: [{
      photo: require("./Photos/виниры_0.jpg"),
      title: _t("Виниры")
    }, {
      photo: require("./Photos/виниры_1.jpg"),
      title: _t("Винир")
    }, {
      photo: require("./Photos/виниры_2.jpg"),
      title: _t("Виниры готовые")
    }, {
      photo: require("./Photos/виниры_3.jpg"),
      title: _t("Виниры на модели")
    }, {
      photo: require("./Photos/виниры_4.jpg"),
      title: _t("Виниры")
    }, {
      photo: require("./Photos/виниры_5.jpg"),
      title: _t("Фиксация виниров")
    }],
    vr: [{
      folder: "Veneer_21",
      xCount: 90,
      yCount: 0,
      title: _t("Винир"),
      preview: require("./VRPacks/Veneer_21/0_6.jpg")
    }, {
      folder: "Veneers",
      xCount: 38,
      yCount: 0,
      title: _t("Виниры на передних зубах"),
      preview: require("./VRPacks/Veneers/0_1.jpg")
    }, {
      folder: "Veneers_2",
      xCount: 91,
      yCount: 0,
      title: _t("Виниры"),
      preview: require("./VRPacks/Veneers_2/0_54.jpg")
    }]
  }, {
    type: "esCrownsSelection",
    title: _t("Коронки"),
    text: _t("<b> Коронка</b> - это несъемный зубной протез, который фиксируется на обточенный зуб для восстановления его формы и цвета. Коронки применяются в стоматологии достаточно давно. На смену металлическим коронкам пришли металлокерамические, а их заменили цельно керамические, коронки из диоксида циркония и дисиликата лития. <br> Такие микропротезы способны полностью восстановить форму и цвет зуба на длительное время и без ущерба для соседних зубов, десен и зубов на противоположной челюсти. Фиксация коронки на обработанный зуб происходит при помощи специальных цементов и клеев. В современной стоматологии используются фиксирующие протоколы и материалы, которые исключают расцементировки и расшатывание коронки. <br> Коронки нельзя использовать без вспомогательных процедур в случаях, если видимая часть зуба разрушена. В таких случаях необходимо в первую очередь восстановить наддесневую часть зуба вкладками и штифтами."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/2.0.5-crowns${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/коронки_1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/коронки_превью_1.jpg`,
      title: _t("Коронки на передние зубы")
    }, {
      video: `${CDN_DOMAIN}/Videos/коронки_2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/коронки_превью_2.jpg`,
      title: _t("Коронки на всю челюсть")
    }, {
      video: `${CDN_DOMAIN}/Videos/коронки_3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/коронки_превью_3.jpg`,
      title: _t("Обработка зубов под коронки")
    }],
    photo: [{
      photo: require("./Photos/коронки_0.jpg"),
      title: _t("Коронка")
    }, {
      photo: require("./Photos/коронки_1.jpg"),
      title: _t("Коронки на верхнюю челюсть")
    }, {
      photo: require("./Photos/коронки_2.jpg"),
      title: _t("Коронки на нижнюю челюсть")
    }, {
      photo: require("./Photos/коронки_3.jpg"),
      title: _t("Коронки")
    }, {
      photo: require("./Photos/коронки_4.jpg"),
      title: _t("Обработка зубов под коронки")
    }, {
      photo: require("./Photos/коронки_5.jpg"),
      title: _t("Обработка зубов под коронки")
    }, {
      photo: require("./Photos/коронки_6.jpg"),
      title: _t("Коронки на верхнюю челюсть")
    }, {
      photo: require("./Photos/коронки_7.jpg"),
      title: _t("Коронки на нижнюю челюсть")
    }],
    vr: [{
      folder: "Crowns",
      xCount: 101,
      yCount: 0,
      title: _t("Коронки"),
      preview: require("./VRPacks/Crowns/0_6.jpg")
    }]
  }, {
    type: "esRestorationsSelection",
    title: _t("Композитные реставрации"),
    text: _t("<b> Композитные реставрации</b> - это поэтапное наслоение фотополимерного материала на зубы для восстановления их формы и цвета. Материал, при помощи которого производят реставрации, представляет собой пластик, наполненный мелкими частичками стеклянных волокон. Слово 'композитный' обозначает, что реставрационный материал состоит из нескольких компонентов, один из которых дает твердость, а другой прочность будущим реставрациям. Из него также изготавливают фотополимерные пломбы на жевательных зубах. Изготавливаются данные реставрации в полости рта, а затвердевают и приобретают прочность при помощи определенного спектра синего цвета, которым засвечивается пломба на каждом слое после нанесения на зуб. Недостатком данной методики является ее недолговечность в сравнении с керамическими коронками или винирами. Преимуществом является скорость изготовления таких реставраций, потому что врач стоматолог имеет возможность изготовить реставрацию прямо во рту пациента за несколько часов. Без снятия оттисков и привлечения зубных техников."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/2.0.4-composit-restavration${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/реставрации_1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрации_превью_1.jpg`,
      title: _t("Композитная реставрация переднего зуба")
    }, {
      video: `${CDN_DOMAIN}/Videos/реставрации_2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрации_превью_2.jpg`,
      title: _t("Композитные реставрации передних зубов")
    }, {
      video: `${CDN_DOMAIN}/Videos/реставрации_3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрации_превью_3.jpg`,
      title: _t("Композитная реставрация скола на зубе")
    }],
    photo: [{
      photo: require("./Photos/реставрации_0.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_1.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_2.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_3.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_4.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_5.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_6.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_7.jpg"),
      title: _t("Реставрации")
    }],
    vr: [{
      folder: "restavrations",
      xCount: 30,
      yCount: 0,
      title: _t("Композитные реставрации"),
      preview: require("./VRPacks/restavrations/0_15.jpg")
    }]
  }, {
    type: "esGumRepair",
    title: _t("Пластика десен"),
    text: _t('<b> Эстетика улыбки во многом зависит от формы десен.</b> К изменению формы десен могут привести заболевания пародонта, хирургические операции в полости рта или неудачное протезирование. Критериями здоровой десны является: здоровый цвет десны, симметричная форма десен в области соединения с зубом относительно противоположной стороны, отсутствие "черных треугольников" между зубами (эффект возникающий при атрофии межзубного сосочка), отсутствие глубоких карманов между десной и зубом, нормальная пропорция между длинной и шириной зуба. При отсутствии хотя бы одного из этих критериев показано лечение десен или гингивальнаяпластика. Во многих случаях при здоровой десне используется изменение формы мягких тканей для достижения максимальной эстетики. Данный подход применим при укороченной видимой части зуба или при отсутствии симметрии десен. <br> <b>Гингивальная пластика (мягкотканная пластика) </b> - это операция по изменению формы десен. Данная манипуляция является малотравматичной и практически безболезненной. При соблюдении должной гигиены эффект может быть достаточно длительным. В настоящее время пластика применяется очень часто в случаях, когда основным запросом при обращении к стоматологу является улучшение эстетики. '),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/2.0.6-restavrations${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/gigivaLaser.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/gingivectomy.png`,
      title: _t("Коррекция формы десен лазером")
    }, {
      video: `${CDN_DOMAIN}/Videos/Гингива Виниры.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Гингива Виниры.jpg`,
      title: _t("Виниринг после гингивальной пластики")
    }, {
      video: `${CDN_DOMAIN}/Videos/гингива длинные шейки.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/гингива длинные шейки.jpg`,
      title: _t("Удлиненные шейки")
    }, {
      video: `${CDN_DOMAIN}/Videos/Гингива черные треугольники.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Гингива черные треугольники.jpg`,
      title: _t("Пластика десны при черных треугольниках")
    }],
    photo: [{
      photo: require("./Photos/Черные треугольники.jpg"),
      title: _t("Черные треугольники")
    }, {
      photo: require("./Photos/Гингива докнормк.5525.jpg"),
      title: _t("Удлиненные шейки")
    }, {
      photo: require("./Photos/Гингива докнорм.5525.jpg"),
      title: _t("Черные треугольники")
    }],
    vr: [{
      folder: "Veneers_gingiva",
      xCount: 78,
      yCount: 0,
      title: _t("Укорочение десен"),
      preview: require("./VRPacks/Veneers_gingiva/0_11.jpg")
    }]
  }, {
    type: "slideSapphireBraces",
    title: _t("Сапфировые брекеты"),
    text: _t("<b>Сапфировые брекеты</b> − это сложные ортодонтические несъёмные конструкции, предназначенные для коррекции положения зубов при нарушениях прикуса и формы зубного ряда. Представляют собой устройства, которые фиксируются при помощи ортодонтического клея (бонда) на наружную поверхность зубов. <br> Такие брекеты изготавливаются из искусственного кристалла сапфира (монокристаллического оксида алюминия). Они обладают наиболее высокой прозрачностью, максимально незаметны и эстетичны. <br> Являются более надежными по сравнению с пластиковыми и керамическими брекетами, более устойчивы к внешним воздействиям. К минусам данных брекетов можно отнести высокую стоимость."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.0.5_sapphireBraces${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/sapphireBraces.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/sapphireBraces.jpg`,
      title: _t("Сапфировые брекеты")
    }],
    photo: [{
      photo: require("./Photos/sapphireBraes.jpg"),
      title: _t("Сапфировые брекеты")
    }, {
      photo: require("./Photos/sapphireBraes1.jpg"),
      title: _t("Сапфировые брекеты")
    }, {
      photo: require("./Photos/sapphireBraes2.jpg"),
      title: _t("Сапфировые брекеты")
    }, {
      photo: require("./Photos/sapphireBraes3.jpg"),
      title: _t("Сапфировые брекеты")
    }],
    vr: [{
      folder: "sapfirBraces",
      xCount: 93,
      yCount: 0,
      title: _t("Сапфировые брекеты"),
      preview: require("./VRPacks/sapfirBraces/0_50.jpg")
    }]
  }, {
    type: "slideSelfAlignBraces",
    title: _t("Самолигирующие брекеты"),
    text: _t("<b> Самолигирующие (они же безлигатурные) брекеты </b> - это системы, в которых ортодонтическая дуга фиксируется при помощи специальных замков. Это основное отличие самолигирующих брекетов от лигатурных, в которых дуга крепится резиновыми лигатурами. Такое крепление позволяет дуге самостоятельно перемещаться в пазах, в зависимости от степени смещения отдельных зубов. <br> Основное преимущество самолигирующих брекетов заключается в том, что они способны сократить срок лечения, а также сократить количества визитов к ортодонту. <br> При ношении самолигирующих брекетов реже возникает боль, так как система работает с меньшими усилиями. Перемещение зубов осуществляется плавно и естественно."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.0.3_selfLigatingMetalBraces${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/self-ligatingBraces.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/self-ligatingBraces.jpg`,
      title: _t("Самолигирующие брекеты")
    }],
    photo: [{
      photo: require("./Photos/ligature1.jpg"),
      title: _t("Металлические самолигирующие брекеты")
    }],
    vr: [{
      folder: "selfLigatyresBraces",
      xCount: 95,
      yCount: 0,
      title: _t("Металлические самолигирующие брекеты"),
      preview: require("./VRPacks/selfLigatyresBraces/0_50.jpg")
    }]
  }, {
    type: "slideCeramicBraces",
    title: _t("Керамические брекеты"),
    text: _t("<b> Керамические брекеты </b> − это сложные ортодонтические несъёмные конструкции для коррекции положения зубов человека при нарушениях прикуса и неровностях зубного ряда. Представляют собой устройства, которые фиксируются при помощи ортодонтического клея (бонда) на наружную или внутреннюю поверхность зубов. Керамическими называют эстетические брекеты, выполненные из поликристаллического оксида алюминия. <br> По сравнению с пластиковыми, керамические брекеты являются более дорогими, но и более прочными. Цвет этих брекетов приближен к естественному цвету эмали зубов, что делает их практически незаметными для окружающих. <br> К минусам керамических брекетов можно отнести более высокое трение между дугой и пазом, в котором лежит дуга - это может увеличить длительность лечения. Для решения этой проблемы иногда в конструкцию внедряется металлический паз, что ухудшает эстетичность."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.0.2_ceramicBraces${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/ceramicBraces.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/ceramicBraces.jpg`,
      title: _t("Керамические брекеты")
    }],
    photo: [{
      photo: require("./Photos/ceramicBraces.jpg"),
      title: _t("Керамические брекеты")
    }, {
      photo: require("./Photos/ceramicBraces1.jpg"),
      title: _t("Керамические брекеты")
    }, {
      photo: require("./Photos/ceramicBraces2.jpg"),
      title: _t("Керамические брекеты")
    }, {
      photo: require("./Photos/ceramicBraces3.jpg"),
      title: _t("Керамические брекеты")
    }],
    vr: [{
      folder: "ceramicBraces",
      xCount: 91,
      yCount: 0,
      title: _t("Керамические брекеты"),
      preview: require("./VRPacks/ceramicBraces/0_50.jpg")
    }]
  }, {
    type: "slideCeramicSelfAlignBraces",
    title: _t("Керамические самолигирующие брекеты"),
    text: _t("<b> Керамические самолигирующие  брекеты </b> - это высоко эстетические ортодонтические системы, в которых дуга фиксируется при помощи специальных замков. Это основное отличие самолигирующих брекетов от лигатурных, в которых дуга крепится резиновыми лигатурами. Такое крепление позволяет дуге самостоятельно перемещаться в пазах, в зависимости от степени смещения отдельных зубов. <br> Основное преимущество самолигирующих брекетов заключается в том, что они способны сократить срок лечения, а также сократить количества визитов к ортодонту. <br> При ношении самолигирующих брекетов реже возникает боль, так как система работает с меньшими усилиями. Перемещение зубов осуществляется плавно и естественно."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.0.4_selfLigatingCeramicBraces${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/брекет самолиг керам.mp4`,
      videoPoster: require("./Photos/ceramicBraces2.jpg"),
      title: _t("Брекеты самолигирующие керамические")
    }],
    photo: [{
      photo: require("./Photos/ceramicBraces2.jpg"),
      title: _t("Керамические самолигирующие брекеты")
    }],
    vr: [{
      folder: "ceramicSelfLigBraces",
      xCount: 95,
      yCount: 0,
      title: _t("Керамические самолигирующие брекеты"),
      preview: require("./VRPacks/ceramicSelfLigBraces/0_50.jpg")
    }]
  }, {
    type: "slideMetallBraces",
    title: _t("Металлические брекеты"),
    text: _t("<b> Металлические брекет системы </b> − это сложные ортодонтические несъёмные конструкции для коррекции положения зубов человека при нарушениях прикуса и неровности зубного ряда. Представляют собой устройства, которые фиксируются при помощи ортодонтического клея (бонда) на наружную или внутреннюю поверхность зубов. <br> Для их изготовления применяются нержавеющая сталь, титан, золото или различные сплавы. Это самые эффективные системы, позволяющие получить идеальный результат лечения в максимально сжатые сроки. <br> Обычные металлические брекеты являются достаточно заметными. Длительность носки брекетов зависит от тяжести деформации зубов."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.0.1_metalBraces${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/classicBraces.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/classicBraces.jpg`,
      title: _t("Классические металлические брекеты")
    }],
    photo: [{
      photo: require("./VRPacks/ligature/0_13.jpg"),
      title: _t("Цветная лигатура на брекетах")
    }],
    vr: [{
      folder: "metallBraces",
      xCount: 94,
      yCount: 0,
      title: _t("Металлические брекеты"),
      preview: require("./VRPacks/metallBraces/0_50.jpg")
    }]
  }, {
    type: "slideLingualBraces",
    title: _t("Лингвальные брекеты"),
    text: _t("<b> Лингвальные брекеты </b>  − это сложные ортодонтические несъёмные конструкции для коррекции положения зубов человека при нарушениях прикуса и неровностях зубного ряда. Представляют собой устройства, которые фиксируются при помощи ортодонтического клея (бонда) на внутреннюю поверхность зубов и совершенно невидимы для окружающих. <br> Лингвальные брекеты относят к эстетическим брекетам. Считается, что это наиболее эстетический способ ортодонтического лечения с помощью несъемных систем. Недостатком таких систем является уменьшение внутренней части полости рта. Поэтому пациенты в первое время испытывают нарушения дикции и повышенный дискомфорт. Как правило, через 2-3 недели язык приспосабливается к уменьшенным размерам полости рта, и дикция становится нормальной."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.0.6_lingualBraces${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/lingualBraces.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/lingualBraces.jpg`,
      title: _t("Лингвальные брекеты")
    }],
    photo: [{
      photo: require("./Photos/lingvalBraces.jpg"),
      title: _t("Лингвальные брекеты")
    }, {
      photo: require("./Photos/lingvalBraces2.jpg"),
      title: _t("Лингвальные брекеты")
    }, {
      photo: require("./Photos/lingvalBraces3.jpg"),
      title: _t("Лингвальные брекеты")
    }, {
      photo: require("./Photos/lingvalBraces4.jpg"),
      title: _t("Лингвальные брекеты")
    }, {
      photo: require("./Photos/lingvalBraces5.jpg"),
      title: _t("Лингвальные брекеты")
    }, {
      photo: require("./Photos/lingvalBraces6.jpg"),
      title: _t("Лингвальные брекеты")
    }, {
      photo: require("./Photos/lingvalBraces7.jpg"),
      title: _t("Лингвальные брекеты")
    }],
    vr: [{
      folder: "lingvalBraces",
      xCount: 85,
      yCount: 0,
      title: _t("Лингвальные брекеты"),
      preview: require("./VRPacks/lingvalBraces/0_50.jpg")
    }]
  }, {
    type: "slideMouthAligner",
    title: _t("Элайнеры"),
    text: _t("<b> Элайнер (align (-er) – выравниватель) </b> – это съёмный ортодонтический аппарат (каппа), выполненный из медицинского полиэстера методом вакуумной формовки, который оказывает дозированную нагрузку на зубы для их перемещения. <br> Элайнеры изготавливаются по мастер-модели, полученной в результате цифрового проектирования и 3D-печати. 3D-технологии используются в большинстве технологических процессов изготовления элайнеров, что обеспечивает высокую точность и предсказуемость результата. <br> Диапазон толщин элайнеров – от 0,5 мм до 1,5 мм. <br> Система элайнеров – это серия элайнеров, которая обеспечивает последовательное дозированное передвижение зубов при поэтапном использовании ортодонтических устройств в соответствии с рекомендациями."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.0.7_aligners${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Alligners2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Alligners2.jpg`,
      title: _t("Элайнер")
    }, {
      video: `${CDN_DOMAIN}/Videos/Aligner_2.mp4`,
      videoPoster: require("./Photos/Капа окклюзионная 2.437.jpg"),
      title: _t("Элайнер, капа")
    }],
    photo: [{
      photo: require("./Photos/aligner1.jpg"),
      title: _t("Элайнер")
    }, {
      photo: require("./Photos/aligner2.jpg"),
      title: _t("Элайнер")
    }, {
      photo: require("./Photos/aligner3.jpg"),
      title: _t("Элайнер")
    }, {
      photo: require("./Photos/aligner4.jpg"),
      title: _t("Элайнеры")
    }, {
      photo: require("./Photos/aligner5.jpg"),
      title: _t("Элайнеры")
    }, {
      photo: require("./Photos/aligner6.jpg"),
      title: _t("Элайнер")
    }],
    vr: [{
      folder: "Aligner",
      xCount: 75,
      yCount: 0,
      title: _t("Элайнер"),
      preview: require("./VRPacks/Aligner/0_40.jpg")
    }]
  }, {
    type: "orthoChildTreatment",
    title: _t("Детская ортодонтия"),
    text: _t("Основным способом лечения детских зубочелюстных аномалий является аппаратное лечение при помощи одночелюстных и двухчелюстных ортодонтических устройств. <br> Существует огромное множество ортодонтических аппаратов, которые различаются по механизму действия, а также по способу фиксации, но все они направлены на нормализацию формы зубных дуг, дыхания пациента, работы языка и мышц лица.<br> К    одночелюстным аппаратам относятся ортодонтические пластины и биоблоки.  <b>Ортодонтические пластинки</b> – это съемные конструкции, основа которых изготавливается из мягкого гипоаллергенного пластика. Терапевтический эффект реализуется за счет постепенного смещения зубного ряда. Система дополнительно включает винты, разнообразные пружины, дуги и крючки. Пластиковая часть конструкции тесно прилегает к небу пациента, в точности повторяя его контуры, а с помощью металлических элементов пластинки происходит ее крепление к зубам с последующим выравниванием. Главную роль играет винт, который находится в различных частях пластмассовой конструкции. Он обеспечивает изменение размеров пластинки, что позволяет влиять на положение челюстей и зубов во рту.<br> К двухчелюстным аппаратам относятся эластопозиционеры, индивидуальные и стандартные разных размеров, форм и жесткости.  <b>Эластопозиционер</b> - это силиконовая каппа, предназначенная для исправления прикуса. Иногда ее еще используют в профилактических целях и в период после ношения брекетов в качестве ретенционного аппарата."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.1.1-childrensOrthodontics${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Ортодонтические_Пластины-18.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Ортодонтические_Пластины-18.jpg`,
      title: _t("Ортодонтические пластины")
    }, {
      video: `${CDN_DOMAIN}/Videos/Пластинка_Ортодонтическая-21.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Пластинка_Ортодонтическая-21.jpg`,
      title: _t("Ортодонтическая пластина")
    }, {
      video: `${CDN_DOMAIN}/Videos/elastopositioner.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/elastopositioner.jpg`,
      title: _t("Эластопозиционер")
    }],
    photo: [{
      photo: require("./Photos/Ortho_plate.jpg"),
      title: _t("Ортодонтические пластины")
    }, {
      photo: require("./Photos/Ortho_plate1.jpg"),
      title: _t("Ортодонтические пластины")
    }, {
      photo: require("./Photos/Ortho_plate2.jpg"),
      title: _t("Ортодонтическая пластина")
    }, {
      photo: require("./Photos/Ortho_plate3.jpg"),
      title: _t("Ортодонтическая пластина")
    }, {
      photo: require("./Photos/Ortho_plate4.jpg"),
      title: _t("Ортодонтические пластины")
    }, {
      photo: require("./Photos/Ortho_plate5.jpg"),
      title: _t("Ортодонтическая пластина")
    }, {
      photo: require("./Photos/Ortho_plate6.jpg"),
      title: _t("Ортодонтическая пластина")
    }]
  }, {
    type: "orthodonticTreatment",
    title: _t("Сохранение ортодонтия"),
    text: _t("Во многих случаях ортодонтического лечения, для достижения запланированного результата, используются дополнительные методики и материалы такие как: .<br> <b>Миниимпланты </b> - это  винтовые титановые имплантаты, предназначенные для создания дополнительных опор ортодонтических систем в случаях, когда зубы не могут выполнить эту роль.<br> <b>Эластические тяги  (Эластики) </b>  применяют для создания дополнительной нагрузки, ускоряющей перемещение зубов в заданном направлении или правильного расположения зубов верхней челюсти относительно зубов нижней челюсти. <br> <b>Сепарации  (Межапроксимальная редукция, IPR) </b>  это шлифование боковых поверхностей зубов, с целью создания места в зубной дуге для корректного положения всех зубов в случаях, когда присутствует дефицит пространства.  <br> И другие. <br> Не стоит забывать, что в конце каждого ортодонтического лечения необходимо применять ретенирование (удержание). <br> <b>Ретенирование</b>   - это то шинирование зубов при помощи съемных или несъемных устройств для их удержания в положении, достигнутом при помощи ортодонтического лечения.  Стандартным сроком использования ритейнеров считается 272 дня. Это срок созревания коллагена вокруг зуба для его стабильно положения в коси. При наличии ряда сопутствующих заболеваний организма данный срок может быть увеличен."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/3.1.2-savingOrtho${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/кнопки_ортодонтические_2_класс_опти.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/кнопки_ортодонтические_2_класс_опти.jpg`,
      title: _t("Эластики II класс по Энглю")
    }, {
      video: `${CDN_DOMAIN}/Videos/Эластики_3_классопти.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Эластики_3_классопти.jpg`,
      title: _t("Эластики III класс по Энглю")
    }, {
      video: `${CDN_DOMAIN}/Videos/Эластики_Для_экструзииопти.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Эластики_Для_экструзииопти.jpg`,
      title: _t("Эластики для экструзии")
    }, {
      video: `${CDN_DOMAIN}/Videos/Эластики_завершающиеопти.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Эластики_завершающиеопти.jpg`,
      title: _t("Завершающие эластики")
    }, {
      video: `${CDN_DOMAIN}/Videos/IPR.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/IPR.jpg`,
      title: _t("Межапроксимальная редукция")
    }, {
      video: `${CDN_DOMAIN}/Videos/reteinerHard.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/reteinerHardPrev.jpg`,
      title: _t("Жесткий несъемный ретейнер")
    }, {
      video: `${CDN_DOMAIN}/Videos/reteinerIndividual.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/reteinerIndividualPrev.jpg`,
      title: _t("Жесткий индивидуальный ретейнер")
    }, {
      video: `${CDN_DOMAIN}/Videos/reteinerRemove.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/reteinerRemovePrev.jpg`,
      title: _t("Съемный ретейнер")
    }],
    photo: [{
      photo: require("./Photos/2_класс_.jpg"),
      title: _t("Эластики II класс по Энглю")
    }, {
      photo: require("./Photos/3_класс.6.jpg"),
      title: _t("Эластики III класс по Энглю")
    }, {
      photo: require("./Photos/Завершающие.jpg"),
      title: _t("Завершающие эластики")
    }, {
      photo: require("./Photos/Экструзия.jpg"),
      title: _t("Эластики для экструзии")
    }, {
      photo: require("./Photos/reteinerHard.jpg"),
      title: _t("Жесткий несъемный ретейнер")
    }, {
      photo: require("./Photos/reteinerHard1.jpg"),
      title: _t("Жесткий несъемный ретейнер")
    }, {
      photo: require("./Photos/reteinerIndividual.jpg"),
      title: _t("Жесткий индивидуальный ретейнер")
    }, {
      photo: require("./Photos/reteinerIndividual1.jpg"),
      title: _t("Жесткий индивидуальный ретейнер")
    }, {
      photo: require("./Photos/reteinerRemove.jpg"),
      title: _t("Съемный ретейнер")
    }, {
      photo: require("./Photos/reteinerRemove1.jpg"),
      title: _t("Съемный ретейнер")
    }]
  }, {
    type: "lowSinus",
    title: _t("Тонкая кость в области гайморовых пазух"),
    text: _t("Ключевым фактором, который определяет возможность имплантации на верхней челюсти в боковых участках, является расстояние между нижним краем челюсти и дном гайморовой пазухи (высоты кости на верхней челюсти). Прослойка костной ткани между корнями жевательных зубов и гайморовой пазухой очень тонкая, что способствует её быстрой атрофии. Истончение кости может быть вызвана сложными удалениями зубов, долговременным отсутствием зубов и, как следствие, атрофия костных тканей, а также воспалительными процессами в пазухах. <br>«Хороший» показатель, это высота 10 мм, либо большее значение. Если толщина кости в данной зоне менее 8 мм, установка имплантов может пройти с осложнениями или невозможна вообще."),
    preview: {
      video: `${CDN_DOMAIN}/Videos/sinus.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/sinus.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/sinus.png`,
      title: _t("Истончение кости в области гайморовых")
    }],
    photo: []
  }, {
    type: "sinusLifting",
    title: _t("Синус-лифтинг"),
    text: _t("<b>Синус-лифтинг</b> - это операция по восстановлению объема костной ткани, необходимого для успешной и безопасной установки имплантата в области гайморовых пазух. Операция синус-лифтинг проводится только при имплантации на верхней челюсти. <br>Существуют две основные методики: открытый синус-лифтинг и закрытый синус-лифтинг. Во время процедуры <b>«Открытый синус</b>-лифтинг» врач разрезает десну с боковой стороны челюсти и просверливает в кости отверстие. Через это отверстие специальными инструментами корректируется дно слизистой оболочки гайморовой пазухи и в образовавшуюся полость добавляется костный материал. После этого кость покрывают барьерной мембраной, а десна ушивается. Открытый синус-лифтинг проводится, когда толщина альвеолярного отростка не превышает 7–8 мм.<br>При выполнении процедуры <b>«Закрытый синус-лифтинг»</b> в лунке зуба высверливается небольшое отверстие, ведущее в гайморову пазуху. Через это отверстие корректируется дно гайморовой пазухи и помещается восстанавливающий костнопластический материал. Такая процедура допускает моментальную установку импланта."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/explainSinus.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Синус_лифтинг_имплантация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Синус_лифтинг_имплантация.jpg`,
      title: _t("Имплантация после синус-лифтинга")
    }, {
      video: `${CDN_DOMAIN}/Videos/Закрытый_синус_лифтинг.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Закрытый_синус_лифтинг.jpg`,
      title: _t("Закрытый синус-лифтинг")
    }, {
      video: `${CDN_DOMAIN}/Videos/Открытый_синус_лифтинг.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Открытый_синус_лифтинг.jpg`,
      title: _t("Открытый синус-лифтинг")
    }],
    photo: [{
      photo: require("./Photos/синус 5.jpg"),
      title: _t("Синус-лифтинг")
    }, {
      photo: require("./Photos/синус 6.jpg"),
      title: _t("Синус-лифтинг")
    }, {
      photo: require("./Photos/синус 7.jpg"),
      title: _t("Синус-лифтинг")
    }]
  }, {
    type: "boneAugmentation",
    title: _t("Костная аугментация"),
    text: _t("<b>Костная аугментация</b> в стоматологической практике применяется для восстановления недостающего объема кости челюсти. Это операции по восстановлению, наращиванию и укреплению костной ткани челюсти при помощи различных методик. Операции по костной регенерации также называют костнопластическими. <br><b>Костная пластика</b> - это операция по наращиванию костной ткани, которая позволяет сформировать достаточное для установки имплантата ложе. В ряде случаев костная пластика проводится одновременно с имплантацией, а в некоторых ситуациях выделяется в отдельную операцию. <br>Достаточный объем костной ткани - важнейший фактор, влияющий на срок службы имплантата, т.к. костная ткань удерживает имплантат (он должен быть окружен ей со всех сторон минимум на 2 мм.). Процесс роста кости происходит таким образом: сначала в образовавшееся пространство врастают новые капилляры. Затем в подсаженный материал проникают клетки-предшественники (здесь решающее значение имеет неподвижность материала). Если клеткам-предшественникам созданы подходящие условия, они превращаются в костные клетки, синтезируют вокруг себя костный матрикс и получается кость."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/ExplainAugment.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Horizontalaugmentation.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Horizontalaugmentation.jpg`,
      title: _t("Горизонтальная аугментация")
    }, {
      video: `${CDN_DOMAIN}/Videos/Verticalaugmentation.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Verticalaugmentation.jpg`,
      title: _t("Вертикальная аугментация")
    }, {
      video: `${CDN_DOMAIN}/Videos/Ugmentationimplantation.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Ugmentationimplantation.jpg`,
      title: _t("Аугментация при имплантации")
    }, {
      video: `${CDN_DOMAIN}/Videos/Восстановление_Костной_Ткани.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Восстановление_Костной_Ткани.jpg`,
      title: _t("Восстановление костной ткани после удаления")
    }],
    photo: [{
      photo: require("./Photos/Восстановление_костной_ткани.jpg"),
      title: _t("Восстановление кости")
    }, {
      photo: require("./Photos/Восстановление_костной_ткани2.jpg"),
      title: _t("Восстановление кости")
    }]
  }, {
    type: "sinusLifting",
    title: _t("Синус-лифтинг"),
    text: _t("<b>Синус-лифтинг</b> - это операция по восстановлению объема костной ткани, необходимого для успешной и безопасной установки имплантата в области гайморовых пазух. Операция синус-лифтинг проводится только при имплантации на верхней челюсти. <br>Существуют две основные методики: открытый синус-лифтинг и закрытый синус-лифтинг. Во время процедуры <b>«Открытый синус</b>-лифтинг» врач разрезает десну с боковой стороны челюсти и просверливает в кости отверстие. Через это отверстие специальными инструментами корректируется дно слизистой оболочки гайморовой пазухи и в образовавшуюся полость добавляется костный материал. После этого кость покрывают барьерной мембраной, а десна ушивается. Открытый синус-лифтинг проводится, когда толщина альвеолярного отростка не превышает 7–8 мм.<br>При выполнении процедуры <b>«Закрытый синус-лифтинг»</b> в лунке зуба высверливается небольшое отверстие, ведущее в гайморову пазуху. Через это отверстие корректируется дно гайморовой пазухи и помещается восстанавливающий костнопластический материал. Такая процедура допускает моментальную установку импланта."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/explainSinus.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Синус_лифтинг_имплантация.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Синус_лифтинг_имплантация.jpg`,
      title: _t("Имплантация после синус-лифтинга")
    }, {
      video: `${CDN_DOMAIN}/Videos/Закрытый_синус_лифтинг.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Закрытый_синус_лифтинг.jpg`,
      title: _t("Закрытый синус-лифтинг")
    }, {
      video: `${CDN_DOMAIN}/Videos/Открытый_синус_лифтинг.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Открытый_синус_лифтинг.jpg`,
      title: _t("Открытый синус-лифтинг")
    }],
    photo: [{
      photo: require("./Photos/синус 5.jpg"),
      title: _t("Синус-лифтинг")
    }, {
      photo: require("./Photos/синус 6.jpg"),
      title: _t("Синус-лифтинг")
    }, {
      photo: require("./Photos/синус 7.jpg"),
      title: _t("Синус-лифтинг")
    }]
  }, {
    type: "sanitation",
    title: _t("Результаты осмотра полости рта"),
    text: _t('<p><strong>Кариес</strong> &mdash; одно из самых распространенных заболеваний полости рта. При его возникновении повреждается сначала зубная эмаль, а затем, если не начать лечение, и дентин (твердая ткань зуба). Первый признак кариеса &mdash; темное пятно на эмали. Если игнорировать его появление, то пятно может увеличиться в диаметре, а затем патология распространяется глубже в ткань зуба, в результате чего образуется "кариозная полость". Когда кариес разрушает эмаль и поражает дентин, то добирается до пульпы (мягкой ткани зуба), что может привести к очень серьезным последствиям. Запущенный кариес зуба, обычно, становится причиной пульпита.<br /><strong>Пульпит</strong> &ndash; болезнь зуба, вызываемая в большинстве случаев проникновением в зубную пульпу болезнетворных бактерий из ротовой полости.&nbsp;В некоторых случаях возможно и ретроградное заражение &ndash; с током крови из-под корня. Такое может произойти, если в организме происходит какой-то инфекционный процесс. Еще одна причина пульпита &ndash; травма, при которой пульпа повреждается в результате механического воздействия.<br />Стоматологические проблемы также могут возникнуть вследствие некачественной пломбировки зубов или лечения каналов. Сломанные инструменты и некачественно запломбированные зубные каналы могут привести к воспалениям и требуют повторного лечения каналов.</p>'),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/4.0.1-OralExamination${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/decayed_tooth_video.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/decayed_tooth-preview.jpg`,
      title: _t("Кариес")
    }, {
      video: `${CDN_DOMAIN}/Videos/Basal Caries.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Basal Caries.jpg`,
      title: _t("Визуальный кариес")
    }, {
      video: `${CDN_DOMAIN}/Videos/Deep Caries.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Deep Caries.jpg`,
      title: _t("Глубокий кариес")
    }, {
      video: `${CDN_DOMAIN}/Videos/пульпит.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/пульпит.jpg`,
      title: _t("Пульпит")
    }, {
      video: `${CDN_DOMAIN}/Videos/Pulpitis.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Pulpitis.jpg`,
      title: _t("Пульпит")
    }],
    photo: [{
      photo: require("./Photos/кариес.112.jpg"),
      title: _t("Кариес")
    }, {
      photo: require("./Photos/кариес.jpg"),
      title: _t("Кариес (46 зуб)")
    }, {
      photo: require("./Photos/Глубокий Кариес.421.jpg"),
      title: _t("Глубокий кариес")
    }, {
      photo: require("./Photos/Пульпит.jpg"),
      title: _t("Пульпит")
    }, {
      photo: require("./Photos/пульпит1.jpg"),
      title: _t("Пульпит")
    }, {
      photo: require("./Photos/Пульпит2.jpg"),
      title: _t("Пульпит")
    }]
  }, {
    type: "affectedAreas",
    title: _t("Детализация зон поражения зубов"),
    text: _t("<p>Кариес может поражать все видимые и невидимые части зуба и поэтому классифицируются несколько видов кариеса.<br /><strong>Пришеечный кариес</strong> &ndash; это кариес, который возникает в приддесневой зоне, возле шейки зуба. В этой зоне эмаль максимально тонкая и поражение сразу развивается в тканях дентина.</p><p><strong>Апроксимальный кариес</strong> (межапроксимальный кариес) поражает боковые поверхности зубов в точках их контакта друг с другом. Данный вид кариеса сложно диагностировать на начальной стадии и трудно поддается лечению из-за затруднения доступа к зоне поражения.</p><p><strong>Фиссурный кариес</strong>&nbsp;&mdash;&nbsp;кариес, который развивается в анатомических углублениях зубов. То есть, заболевание поражает жевательные части коронок зубов.<br />Также кариес может развиваться на жевательных поверхностях зубов вследствие повышенной стираемости.&shy;&shy;&shy;</p>"),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/4.0.2-DetailingOfAffectedAreas${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Deep Caries.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Deep Caries.jpg`,
      title: _t("Глубокий кариес")
    }, {
      video: `${CDN_DOMAIN}/Videos/Fissures Caries.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Fissures Caries.jpg`,
      title: _t("Фиссурный кариес")
    }, {
      video: `${CDN_DOMAIN}/Videos/Cervical Caries.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Cervical Caries.jpg`,
      title: _t("Пришеечный кариес")
    }, {
      video: `${CDN_DOMAIN}/Videos/Approximal caries.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/AproximalCaries.png`,
      title: _t("Апроксимальный кариес")
    }],
    photo: [{
      photo: require("./Photos/Апроксимальный кариес2.jpg"),
      title: _t("Апроксимальный кариес")
    }, {
      photo: require("./Photos/Глубокий Кариес.421.jpg"),
      title: _t("Глубокий кариес")
    }, {
      photo: require("./Photos/прикорневой.423.jpg"),
      title: _t("Прикорневой кариес")
    }, {
      photo: require("./Photos/пришеечный кариес.427.jpg"),
      title: _t("Пришеечный кариес")
    }, {
      photo: require("./Photos/Фиссурный кариес.431.jpg"),
      title: _t("Фиссурный кариес")
    }, {
      photo: require("./Photos/Пультит.429.jpg"),
      title: _t("Глубокий кариес")
    }]
  }, {
    type: "rootsInflammation",
    title: _t("Воспаления на корнях"),
    text: _t("<p><strong>Периодонтит</strong> &ndash; это воспаление тканей, окружающих корень зуба. У корня образуется наполненный гноем карман. У пациентов возникают сильные болевые ощущения. Прием обезболивающих препаратов приносит лишь временное облегчение, но проблему не устраняет.</p><p>Различают следующие разновидности заболевания:</p><p>- инфекционный периодонтит может развиться, если был запущен и не вылечен кариес, пульпит;</p><p>- медикаментозный периодонтит наблюдается из-за неправильно проведенной стоматологической терапии (периодонтит после лечения);</p><p>- травматический периодонтит развивается вследствие полученной травмы.</p><p>Болезнь чаще возникает при длительно протекающем кариесе, либо после его лечения, если в ходе процедуры стоматолог не полностью устранил очаг инфекции.</p>"),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/4.0.3-InflammationInTheRoots${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Периодотит.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Периодотит.jpg`,
      title: _t("Периодонтит")
    }],
    photo: [{
      photo: require("./Photos/переодонт.jpg"),
      title: _t("Периодонт")
    }, {
      photo: require("./Photos/переодонт1.jpg"),
      title: _t("Периодонт")
    }, {
      photo: require("./Photos/переодонт3.jpg"),
      title: _t("Периодонт")
    }, {
      photo: require("./Photos/киста.jpg"),
      title: _t("Киста")
    }, {
      photo: require("./Photos/Киста_гранулема.jpg"),
      title: _t("Киста, гранулема")
    }, {
      photo: require("./Photos/Киста_гранулема_2.jpg"),
      title: _t("Киста, гранулема")
    }]
  }, {
    type: "suggestedTreatment",
    title: _t("Предложенное лечение"),
    text: _t("<p><strong>Лечение зубов</strong>&nbsp;&ndash;&nbsp;это&nbsp;в первую очередь лечение кариеса, а также его осложнений: пульпита и периодонтита.</p><p>Терапевтическое лечение зубов состоит из ряда последовательных процедур:</p><p>- очистка зуба, подлежащего лечению, от зубного налета и зубного камня;</p><p>- анестезия;</p><p>- препарирование кариозной полости;</p><p>- удаление пульпы (при лечении пульпита);</p><p>- распломбировка каналов (в случае с некачественной пломбировки каналов при неудачном лечении);</p><p>- антисептическая обработка и введение лекарственных средств;</p><p>- пломбирование корневых каналов &nbsp;горячей гуттаперчей;</p><p>- пломбирование коронкой части зуба.</p><p>Периодонтит лечится как хирургическим способом, так и консервативным, терапевтическим.</p><p>Хирургическим способом подразумевает удаление гнойного образования вместе с пораженными тканями зуба.</p><p>Терапевтический способ подразумевает снятие воспаления, используя доступ к очагу через канал зуба.</p><p>При лечении зуба, если наддесневая часть сильно разрушена, могут применяться стекловолоконные штифты при пломбировании каналов для восстановления коронки зуба.</p>"),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/4.0.4-SuggestedTreatment${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Зубной камень.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Зубной камень.jpg`,
      title: _t("Зубной камень")
    }, {
      video: `${CDN_DOMAIN}/Videos/постоянная пломба.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/постоянная пломба.jpg`,
      title: _t("Композитная пломба")
    }, {
      video: `${CDN_DOMAIN}/Videos/временная пломба.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/временная пломба.jpg`,
      title: _t("Временная пломба")
    }, {
      video: `${CDN_DOMAIN}/Videos/Ceramic Tabs.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Ceramic Tabs.jpg`,
      title: _t("Керамические вкладки")
    }, {
      video: `${CDN_DOMAIN}/Videos/Пломбировка канала.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Пломбировка канала.jpg`,
      title: _t("Пломбировка канала")
    }, {
      video: `${CDN_DOMAIN}/Videos/реставрация культи зуба.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрация культи зуба.jpg`,
      title: _t("Реставрация культи зуба")
    }, {
      video: `${CDN_DOMAIN}/Videos/Resection.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/resection-preview.png`,
      title: _t("Резекция корня")
    }],
    photo: [{
      photo: require("./Photos/камень зубной.jpg"),
      title: _t("Камень зубной")
    }, {
      photo: require("./Photos/камень.jpg"),
      title: _t("Зубной камень")
    }, {
      photo: require("./Photos/пломба.jpg"),
      title: _t("Пломба")
    }, {
      photo: require("./Photos/пломба1.jpg"),
      title: _t("Композитная пломба")
    }, {
      photo: require("./Photos/пломба2.jpg"),
      title: _t("Временная пломба")
    }, {
      photo: require("./Photos/пломба3.jpg"),
      title: _t("Временная пломба")
    }, {
      photo: require("./Photos/пломба4.jpg"),
      title: _t("Зубная пломба")
    }, {
      photo: require("./Photos/пломба5.jpg"),
      title: _t("Пломба")
    }, {
      photo: require("./Photos/rootChannels3.jpg"),
      title: _t("Пломбировка канала")
    }, {
      photo: require("./Photos/rootChannels4.jpg"),
      title: _t("Пломбировка канала")
    }, {
      photo: require("./Photos/rootChannels.jpg"),
      title: _t("Каналы верхних зубов")
    }, {
      photo: require("./Photos/rootChannels2.jpg"),
      title: _t("Каналы нижних зубов")
    }, {
      photo: require("./Photos/Разрушенная коронка зуба 2.jpg"),
      title: _t("Разрушенная коронка зуба")
    }, {
      photo: require("./Photos/Разрушенная коронка зуба4.jpg"),
      title: _t("Разрушенная коронка зуба")
    }, {
      photo: require("./Photos/культи зуб.jpg"),
      title: _t("Восстановление коронки зуба")
    }, {
      photo: require("./Photos/культи зуб1.jpg"),
      title: _t("Восстановление коронки зуба")
    }, {
      photo: require("./Photos/resection-photo_1.jpg"),
      title: _t("Резекция корня")
    }, {
      photo: require("./Photos/resection-photo_2.jpg"),
      title: _t("Резекция корня")
    }, {
      photo: require("./Photos/resection-photo_3.jpg"),
      title: _t("Резекция корня")
    }],
    vr: [{
      folder: "tabs",
      xCount: 89,
      yCount: 0,
      title: _t("Керамические вкладки"),
      preview: require("./VRPacks/tabs/0_1.jpg")
    }]
  }, {
    type: "saveTherapy",
    title: _t("Сохранение результатов лечения"),
    text: _t("<p><strong>Для предотвращения болезней зубов в будущем необходимо придерживаться правил профилактики ротовой полости.</strong></p><p><strong>Профилактика ротовой полости:</strong></p><p>- домашняя чистка зубов минимум 2 раза в день с использованием правильно подобранной зубной щетки, зубной нити и ополаскивателей (при рекомендации врача, также специальными флосами и ершиками);</p><p>- профессиональная чистка зубов 1 раз в пол года или 3 месяца (в зависимости от пародонтологического статуса);</p><p>- регулярное посещение врача стоматолога-терапевта для осмотра полости рта и выявления очагов болезней зубов и десен;</p><p>- немедленное лечение в случае выявления очагов зарождения кариеса или пародонтологических проблем.</p>"),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/4.0.5-Preservation${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Зубной камень.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Зубной камень.jpg`,
      title: _t("Зубной камень")
    }, {
      video: `${CDN_DOMAIN}/Videos/skeling.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/skeling.jpg`,
      title: _t("Скейлинг, полировка корня")
    }],
    photo: [{
      photo: require("./Photos/камень зубной.jpg"),
      title: _t("Камень зубной")
    }, {
      photo: require("./Photos/камень.jpg"),
      title: _t("Зубной камень")
    }, {
      photo: require("./Photos/skeling.jpg"),
      title: _t("Скейлинг, полировка корня")
    }, {
      photo: require("./Photos/skeling1.jpg"),
      title: _t("Удаление камня")
    }, {
      photo: require("./Photos/skeling2.jpg"),
      title: _t("Очистка корня")
    }]
  }, {
    type: "additionalRestorations",
    title: _t("Выбор дополнительных реставраций"),
    text: _t("<p>Для улучшения эстетики зубов в зоне улыбки могут применяться эстетические композитные реставрации на зубах, которые находятся рядом с пролеченными.</p><p>В большинстве случаев нецелесообразно имитировать разрушенную потемневшую эмаль соседнего зуба при реставрации коронковой части зуба, который подвергался лечению. В таком случае, более корректным подходом для достижения эстетики, является полноценная реставрация анатомической формы зуба и восстановление формы и цвета соседних зубов. Подобное решение очень часто принимается в рамках восстановления формы зубов при повышенной или возрастной стираемости, а также для достижения более светлого цвета зубов в зоне улыбки.</p>"),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/4.0.6-ChoiceOfAdditionalRestorations${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/реставрации_1.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрации_превью_1.jpg`,
      title: _t("Композитная реставрация")
    }],
    photo: [{
      photo: require("./Photos/реставрации_1.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_3.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_4.jpg"),
      title: _t("Реставрации")
    }]
  }, {
    type: "refinementRestorationAreas",
    title: _t("Уточнение зон реставраций"),
    text: _t("<b> Композитные реставрации</b> - это поэтапное наслоение фотополимерного материала на зубы для восстановления их формы и цвета. Материал, при помощи которого производят реставрации, представляет собой пластик, наполненный мелкими частичками стеклянных волокон. Слово 'композитный' обозначает, что реставрационный материал состоит из нескольких компонентов, один из которых дает твердость, а другой прочность будущим реставрациям. Из него также изготавливают фотополимерные пломбы на жевательных зубах. Изготавливаются данные реставрации в полости рта, а затвердевают и приобретают прочность при помощи определенного спектра синего цвета, которым засвечивается пломба на каждом слое после нанесения на зуб. Недостатком данной методики является ее недолговечность в сравнении с керамическими коронками или винирами. Преимуществом является скорость изготовления таких реставраций, потому что врач стоматолог имеет возможность изготовить реставрацию прямо во рту пациента за несколько часов. Без снятия оттисков и привлечения зубных техников."),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/2.0.4-composit-restavration${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/реставрации_2.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрации_превью_2.jpg`,
      title: _t("Композитные реставрации передних зубов")
    }, {
      video: `${CDN_DOMAIN}/Videos/реставрации_3.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/реставрации_превью_3.jpg`,
      title: _t("Композитная реставрация скола на зубе")
    }],
    photo: [{
      photo: require("./Photos/реставрации_0.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_2.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_5.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_6.jpg"),
      title: _t("Реставрации")
    }, {
      photo: require("./Photos/реставрации_7.jpg"),
      title: _t("Реставрации")
    }],
    vr: [{
      folder: "restavrations",
      xCount: 30,
      yCount: 0,
      title: _t("Композитные реставрации"),
      preview: require("./VRPacks/restavrations/0_15.jpg")
    }]
  }, {
    type: "canalFillingTerapy",
    title: _t("Пломбировка каналов"),
    text: _t("<p><strong>Пломбирование корневых каналов</strong>&nbsp;&ndash; это процедура, которая применяется в случае удаления пульпы зуба и после очистки каналов. Может применяться на здоровых зубах в случаях, когда на эти зубы планируется установка коронок для фиксации мостовидного протеза. А также в случаях, когда высота коронковой части зуба не позволяет произвести полноценную реставрацию или создать опору для будущей коронки. В таком случае зуб депульпируется для установки стекловолоконного штифта.</p>"),
    preview: {
      video: `${CDN_DOMAIN}/VideosPreview/4.0.7-CanalFilling${langPrefix}.mp4`
    },
    video: [{
      video: `${CDN_DOMAIN}/Videos/Пломбировка канала.mp4`,
      videoPoster: `${CDN_DOMAIN}/Videos/Пломбировка канала.jpg`,
      title: _t("Пломбировка канала")
    }],
    photo: [{
      photo: require("./Photos/rootChannels3.jpg"),
      title: _t("Пломбировка канала")
    }, {
      photo: require("./Photos/rootChannels4.jpg"),
      title: _t("Пломбировка канала")
    }, {
      photo: require("./Photos/rootChannels.jpg"),
      title: _t("Каналы верхних зубов")
    }, {
      photo: require("./Photos/rootChannels2.jpg"),
      title: _t("Каналы нижних зубов")
    }]
  }];
};

export default BarInfo;